// 意大利语
import itLocale from 'element-ui/lib/locale/lang/it'


const it = {
  // ============== 登陆页 start=============
  "登录": "Accedi",
  "退出": "Esci",
  "账号": "Account",
  "密码": "Password",
  "验证码": "Codice di verifica",
  "请输入账号": "Inserisci il tuo account",
  "请输入密码": "Inserisci la tua password",
  "请输入验证码": "Inserisci il codice di verifica",
  "验证码不正确": "Codice di verifica errato",
  "没有账号": "Nessun account",
  "请": "Per favore",
  "点击注册": "Clicca per registrarti",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Totale Negozi",
  "用户总量": "Conteggio Utenti Complessivo",
  "营业总量": "Fatturato Totale",
  "订单总量": "Volume Totale degli Ordini",
  "商品总量": "Conteggio Totale dell'Inventario",
  "销售总额": "Vendite Totali",
  "元": "€",
  "预计收入": "Entrate Stimato",
  "今日概况": "Sommario di Oggi",
  "销售额": "Volume di Vendita",
  "支付订单数": "Ordini Pagati",
  "昨日": "Ieri",
  "新增用户数": "Nuovi Utenti",
  "新增商户": "Nuovi Commercianti",
  "下单用户数": "Utenti che Effettuano Ordinazioni",
  "待办事项": "Compiti in Sospeso",
  "请尽快处理，以免影响营业": "Si prega di affrontare prontamente per evitare impatti sul business",
  "待处理订单": "Ordini in Elaborazione",
  "库存告急": "Emergenza di Inventario",
  "商品排行榜": "Classifica dei Prodotti Migliori",
  "销量": "Volume di Vendite",
  "暂无上榜记录": "Nessun Record di Classifica al Momento",
  "成交额": "Volume di Transazione",
  "成交量": "Ordini di Transazione",
  "退单额": "Volume Totale dei Rimborsi",
  "退单量": "Ordini di Rimborso",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Informazioni di Base",
  "编辑门店": "Modifica Negozio",
  "官方网站": "Sito Ufficiale",
  "门店服务": "Servizi del Negozio",
  "服务与营业时间": "Servizi e Orari di Apertura",
  "桌码管理": "Gestione dei Codici Tavolo",
  "收银台": "Cassa",
  "后厨": "Cucina",
  "商品": "Merci",
  "商品分类": "Classificazione Merci",
  "添加商品": "Aggiungi Merci",
  "网站": "Sito Web",
  "网站编辑": "Modifica Sito Web",
  "资讯": "Informazioni",
  "上一步": "Passaggio Precedente",
  "保存": "Salva",
  "下一步": "Passaggio Successivo",
  "提交失败": "Invio Fallito",
  "获取当前进度信息失败": "Fallita l'Ottenimento delle Informazioni di Avanzamento Attuali",
  "门店名称": "Nome del Negozio",
  "请输入门店名称": "Inserisci il Nome del Negozio",
  "登录密码": "Password di Accesso",
  "请输入登录密码": "Inserisci la Password di Accesso",
  "确认密码": "Conferma Password",
  "请输入确认密码": "Inserisci la Conferma Password",
  "联系人": "Contatto",
  "请输入联系人": "Inserisci il Nome di Contatto",
  "联系电话": "Telefono di Contatto",
  "请输入联系电话": "Inserisci il Numero di Telefono di Contatto",
  "店铺类型": "Tipo di Negozio",
  "分店": "Succursale",
  "直营": "Vendita Diretta",
  "同步主店": "Sincronizza con il Negozio Principale",
  "分店创建": "Creazione di Succursale",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Gentile Promemoria: Dopo aver scelto, si prega di non modificare casualmente per evitare la confusione dei dati dei prodotti del negozio",
  "绑定用户": "Associa Utente",
  "选择用户": "Seleziona Utente",
  "用户昵称": "Soprannome",
  "选择图片": "Seleziona Immagine",
  "地址": "Indirizzo",
  "请输入地址": "Inserisci l'Indirizzo",
  "门店坐标": "Coordinate del Negozio",
  "商家介绍": "Presentazione del Commerciante",
  "状态": "Stato",
  "开启": "Aperto",
  "禁止": "Chiuso",
  "营业状态": "Stato di Apertura",
  "营业中": "Aperto",
  "停止营业": "Chiuso",
  "上传图片": "Carica Immagine",
  "获取当前门店失败，请刷新界面重试": "Impossibile recuperare il negozio corrente, si prega di aggiornare la pagina e riprovare",
  "商城设置": "Impostazioni del Centro Commerciale",
  "商城名称": "Nome del Centro Commerciale",
  "商城名称不能为空": "Il Nome del Centro Commerciale Non Può Essere Vuoto",
  "访问网址后缀": "Suffisso dell'URL di Accesso",
  "访问网址": "Visita URL",
  "手机网站": "Sito Web Mobile",
  "默认": "Predefinito",
  "自定义": "Personalizzato",
  "Pad点餐网站": "Sito Web di Ordinazione Pad",
  "收银台网站": "Sito Web della Cassa",
  "后厨网站": "Sito Web della Cucina",
  "会员设置": "Impostazioni dei Membri",
  "请选择默认头像": "Per favore Seleziona l'Avatar Predefinito",
  "门店二维码": "QR Code del Negozio",
  "下载": "Scarica",
  "营业时间": "Orari di Apertura",
  "店内营业时间": "Orari di Apertura in Negozio",
  "请选择店内营业时间": "Per favore Seleziona gli Orari di Apertura in Negozio",
  "开始时间": "Ora di Inizio",
  "结束时间": "Ora di Fine",
  "至": "A",
  "选择时间范围": "Seleziona l'Intervallo di Tempo",
  "自提营业时间": "Orari di Ritiro in Negozio",
  "请选择自提营业时间": "Per favore Seleziona gli Orari di Ritiro in Negozio",
  "外卖营业时间": "Orari di Asporto",
  "请选择外卖营业时间": "Per favore Seleziona gli Orari di Asporto",
  "外卖配送": "Consegna a Domicilio",
  "注": "Nota",
  "外卖配送方式至少选择一个": "Deve essere selezionato almeno un metodo di consegna a domicilio",
  "店内配置": "Configurazione in Negozio",
  "店内用餐方式至少选择一个": "Deve essere selezionato almeno un metodo di consumazione in negozio",
  "堂食服务": "Servizio al Tavolo",
  "店内堂食结算模式": "Modalità di Pagamento per Consumazione in Negozio",
  "先结账后用餐": "Paga Prima, Poi Consuma",
  "先用餐后结账": "Consuma Prima, Poi Paga",
  "收银台桌台清台设置": "Impostazioni di Pulizia del Tavolo della Cassa",
  "定时清台": "Pulizia Programmata del Tavolo",
  "立即清台": "Pulizia Immediata del Tavolo",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Dopo aver attivato la pulizia programmata del tavolo, il sistema cancellerà automaticamente il tavolo dell'ordinazione alla cassa dopo il tempo impostato. Questa funzione è attiva solo nella modalità di pagamento anticipato",
  "桌台订单清台设置": "Impostazioni di Pulizia dell'Ordinazione del Tavolo",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Pulire automaticamente il tavolo dopo minuti (tempo programmato per l'ordinazione con scansione del codice tavolo e tempo programmato per la pulizia della cassa)",
  "店内堂食服务费": "Costo del Servizio al Tavolo in Negozio",
  "按就餐人数收取": "Addebito in Base al Numero di Clienti",
  "按每桌台收取": "Addebito per Tavolo",
  "请输入服务费": "Inserisci il Costo del Servizio",
  "位": "Posto",
  "桌": "Tavolo",
  "店内包装费类型": "Tipo di Costo di Confezionamento in Negozio",
  "按商品收费": "Addebito in Base ai Prodotti",
  "按单收费": "Addebito per Ordine",
  "包装费": "Costo del Confezionamento",
  "请输入包装费": "Inserisci il Costo del Confezionamento",
  "外卖服务": "Servizio di Asporto",
  "外卖包装费类型": "Tipo di Costo del Confezionamento per l'Asporto",
  "外卖配送范围": "Area di Consegna a Domicilio",
  "请输入外卖配送范围": "Inserisci l'Area di Consegna a Domicilio",
  "外卖配送费": "Costo della Consegna a Domicilio",
  "请输入外卖配送费": "Inserisci il Costo della Consegna a Domicilio",
  "最低消费": "Consumo Minimo",
  "请输入最低消费": "Inserisci il Consumo Minimo",
  "添加类型": "Aggiungi Tipo",
  "类型名称": "Nome del Tipo",
  "人数区间": "Intervallo di Persone",
  "添加时间": "Aggiungi Orario",
  "操作": "Operazione",
  "删除": "Elimina",
  "桌位管理": "Gestione del Tavolo",
  "最少人数": "Minimo Numero di Persone",
  "最多人数": "Massimo Numero di Persone",
  "取 消": "Annulla",
  "确 定": "Conferma",
  "请输入类型名称": "Inserisci il Nome del Tipo",
  "排序不能为空": "L'Ordinamento Non Può Essere Vuoto",
  "排序必须为数字": "L'Ordinamento Deve Essere un Numero",
  "添加成功": "Aggiunto con Successo",
  "修改类型": "Modifica Tipo",
  "修改成功": "Modificato con Successo",
  "添加区域": "Aggiungi Area",
  "区域名称": "Nome dell'Area",
  "修改区域": "Modifica Area",
  "请输入区域名称": "Inserisci il Nome dell'Area",
  "分类名称": "Nome della Categoria",
  "编号": "Numero",
  "选择区域": "Seleziona Area",
  "请选择": "Per favore Seleziona",
  "选择类型": "Seleziona Tipo",
  "查询": "Ricerca",
  "桌号id": "ID del Tavolo",
  "所属区域": "Area di Appartenenza",
  "桌位类型": "Tipo di Tavolo",
  "桌位编码": "Codice del Tavolo",
  "人": "Persone",
  "二维码": "QR Code",
  "桌位编号": "Numero del Tavolo",
  "请输入桌位编号": "Inserisci il Numero del Tavolo",
  "请选择类型名称": "Per favore Seleziona il Nome del Tipo",
  "请选择所属区域": "Per favore Seleziona l'Area di Appartenenza",
  "添加桌位": "Aggiungi Tavolo",
  "关键词": "Parola Chiave",
  "添加收银员": "Aggiungi Cassiere",
  "姓名": "Nome",
  "登录账号": "Account di Accesso",
  "联系方式": "Metodo di Contatto",
  "收银员管理": "Gestione Cassieri",
  "编辑": "Modifica",
  "手机号": "Numero di Telefono",
  "请输入登录账号": "Si prega di inserire l'account di accesso",
  "长度在6到16个字符": "Lunghezza compresa tra 6 e 16 caratteri",
  "两次输入密码不一致！": "Le due password inserite non coincidono!",
  "禁用": "Disabilita",
  "删除后不可恢复，确认删除该记录吗?": "Non può essere recuperato dopo l'eliminazione, confermi l'eliminazione di questo record?",
  "提示": "Avviso",
  "后厨人员管理": "Gestione del Personale di Cucina",
  "添加后厨人员": "Aggiungi Personale di Cucina",
  "添加后厨账号": "Aggiungi Account della Cucina",
  "普通分类": "Classificazione Generale",
  "添加分类": "Aggiungi Categoria",
  "图片": "Immagine",
  "分类排序": "Ordinamento delle Categorie",
  "税率设置": "Impostazione dell'Aliquota Fiscale",
  "添加税率": "Aggiungi Aliquota Fiscale",
  "税率分类名称": "Nome della Categoria dell'Aliquota Fiscale",
  "税率": "Aliquota Fiscale",
  "适用于菜品分类": "Applicabile alla Classificazione dei Piatti",
  "未找到相应数据": "Nessun Dato Corrispondente Trovato",
  "请输入分类名称": "Si prega di inserire il nome della categoria",
  "分类排序不能为空": "L'ordinamento delle categorie non può essere vuoto",
  "分类排序必须为数字": "L'ordinamento delle categorie deve essere un numero",
  "正在翻译，请稍后": "Traduzione in corso, si prega di attendere",
  "多语言翻译": "Traduzione Multilingue",
  "修改分类": "Modifica Categoria",
  "翻译": "Traduzione",
  "分类图片": "Immagine della Categoria",
  "外卖商品": "Prodotti da Asporto",
  "店内商品": "Prodotti in Negozio",
  "商品管理": "Gestione dei Prodotti",
  "分类管理": "Gestione delle Categorie",
  "上架中": "In Vendita",
  "下架": "Fuori Dallo Scaffale",
  "商品名称": "Nome del Prodotto",
  "请输入商品名称": "Si prega di inserire il nome del prodotto",
  "添加产品": "Aggiungi Prodotto",
  "全部": "Tutti",
  "产品": "Prodotto",
  "实际销量": "Vendite Effettive",
  "库存": "Inventario",
  "发布时间": "Orario di Pubblicazione",
  "销售价": "Prezzo di Vendita",
  "下架中": "Fuori Dallo Scaffale",
  "强制下架": "Rimuovi Forzatamente Dallo Scaffale",
  "重新上架": "Rimetti in Vendita",
  "上架": "Inserisci in Vendita",
  "确认要": "Confermare di",
  "成功": "Successo",
  "删除成功": "Eliminazione Riuscita",
  "请先选择一个选项": "Si prega di selezionare prima un'opzione",
  "正在完成翻译，请稍后操作": "Completando la traduzione, si prega di operare più tardi",
  "请检查表单的必填项是否全部填写": "Si prega di verificare che tutti gli elementi obbligatori nel modulo siano stati compilati",
  "补全成功": "Completamento Riuscito",
  "主语言选择": "Selezione della Lingua Principale",
  "请选择主语言": "Si prega di selezionare la lingua principale",
  "高级设置": "Impostazioni Avanzate",
  "取消": "Annulla",
  "修改": "Modifica",
  "保存成功": "Salvataggio Riuscito",
  "规格": "Specifiche",
  "库存计算方式": "Metodo di Calcolo dell'Inventario",
  "下单减库存": "Ordine per Ridurre l'Inventario",
  "特色分类": "Classificazione in Primo Piano",
  "产品规格": "Specifiche del Prodotto",
  "单规格": "Singola Specifica",
  "多规格": "Specifiche Multiple",
  "此商品正在参加活动，不能修改规格": "Questo prodotto sta partecipando a un'attività e non può modificare le specifiche",
  "基本信息": "Informazioni di Base",
  "AI魔法创建": "Creazione Magica con AI",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Attraverso la tecnologia dell'intelligenza artificiale, è possibile compilare automaticamente le informazioni dettagliate sul prodotto in base al nome del prodotto, come ingredienti, punti vendita, gusti, ecc.",
  "所属分类": "Categoria Appartenente",
  "请选择商品分类": "Si prega di selezionare la categoria del prodotto",
  "请填写商品详情": "Si prega di compilare i dettagli del prodotto",
  "商品详情": "Dettagli del Prodotto",
  "换一换": "Cambia",
  "产品价格": "Prezzo del Prodotto",
  "请填写产品价格": "Si prega di inserire il prezzo del prodotto",
  "请填写包装费": "Si prega di compilare la tassa di imballaggio",
  "规格明细": "Dettagli delle Specifiche",
  "规格名称": "Nome della Specifica",
  "请输入内容": "Si prega di inserire il contenuto",
  "价格": "Prezzo",
  "添加规格": "Aggiungi Specifica",
  "商品图片": "Immagine del Prodotto",
  "请上传商品图片": "Si prega di caricare l'immagine del prodotto",
  "从AI图库中选择": "Scegli dall'Archivio Immagini AI",
  "使用中文从AI图库搜索": "Utilizzare il cinese per cercare nell'Archivio Immagini AI",
  "AI图库": "Archivio Immagini AI",
  "确认使用": "Conferma Utilizzo",
  "AI未识别到您的商品图片": "L'AI non ha riconosciuto l'immagine del tuo prodotto",
  "可在搜索框": "Disponibile nella casella di ricerca",
  "更换菜品名称": "Cambia il Nome del Piatto",
  "请输入菜品名称！": "Si prega di inserire il nome del piatto!",
  "请在主语言界面上进行操作": "Si prega di operare sull'interfaccia della lingua principale",
  "本商品正在参加活动，不能删除规格！": "Questo prodotto sta partecipando a un'attività e non può eliminare le specifiche!",
  "不能再删除了": "Impossibile Eliminare Ulteriormente",
  "多语言": "Multilingua",
  "商品加料": "Ingredienti del Prodotto",
  "添加加料": "Aggiungi Ingredienti",
  "加料名称": "Nome dell'Additivo",
  "如:杯型": "Come: Tipo di Coppa",
  "内容": "Contenuto",
  "积分设置": "Impostazione dei Punti",
  "是否开启积分赠送": "Se Abilitare il Regalo dei Punti",
  "关闭": "Chiudi",
  "其他设置": "Altre Impostazioni",
  "商品状态": "Stato del Prodotto",
  "选择商品状态": "Seleziona lo Stato del Prodotto",
  "初始销量": "Vendite Iniziali",
  "商品排序": "Ordinamento dei Prodotti",
  "限购数量": "Quantità Limite d'Acquisto",
  "每个会员购买的最大数量，0为不限购": "Il numero massimo di acquisti per ogni membro, 0 significa senza limiti",
  "会员折扣设置": "Impostazione dello Sconto per i Membri",
  "是否开启会员折扣": "Se Abilitare lo Sconto per i Membri",
  "默认折扣": "Sconto Predefinito",
  "单独设置折扣": "Imposta lo Sconto Singolarmente",
  "默认折扣：默认为用户所属会员等级的折扣率": "Sconto Predefinito: di default è il tasso di sconto del livello di membri a cui l'utente appartiene",
  "折扣佣金类型": "Tipo di Commissione sugli Sconti",
  "百分比": "Percentuale",
  "固定金额": "Importo Fisso",
  "会员等级": "Livello del Membro",
  "折扣": "Sconto",
  "请输入折扣": "Si prega di inserire lo sconto",
  "分销设置": "Impostazioni di Distribuzione",
  "是否开启分销": "Se Abilitare la Distribuzione",
  "分销规则": "Regole di Distribuzione",
  "平台规则": "Regole della Piattaforma",
  "单独规则": "Regole Separate",
  "平台规则：层级": "Regole della Piattaforma: Livello",
  "1级佣金": "Commissione di Livello 1",
  "2级佣金": "Commissione di Livello 2",
  "3级佣金": "Commissione di Livello 3",
  "分销佣金类型": "Tipo di Commissione di Distribuzione",
  "单独分销设置": "Impostazione di Distribuzione Separata",
  "一级佣金": "Commissione di Livello 1",
  "二级佣金": "Commissione di Livello 2",
  "三级佣金": "Commissione di Livello 3",
  "请填写商品名称": "Si prega di compilare il nome del prodotto",
  "你选择商品分类": "Hai Scelto la Categoria del Prodotto",
  "商品卖点": "Punto Vendita del Prodotto",
  "配料": "Ingredienti",
  "添加项": "Aggiungi Elemento",
  "删除项": "Elimina Elemento",
  "审核状态": "Stato di Revisione",
  "选择审核状态": "Seleziona lo Stato di Revisione",
  "通过": "Approvato",
  "未通过": "Non Approvato",
  "审核备注": "Nota di Revisione",
  "请输入拒绝原因": "Si prega di inserire il motivo del rifiuto",
  "商品属性": "Attributi del Prodotto",
  "添加属性": "Aggiungi Attributi",
  "属性名称": "Nome dell'Attributo",
  "属性值": "Valore dell'Attributo",
  "至少填写两个": "Almeno due campi devono essere compilati",
  "如:温度": "Come: Temperatura",
  "口味": "Gusto",
  "商品同步": "Sincronizzazione dei Prodotti",
  "同步至外卖": "Sincronizza con il Servizio da Asporto",
  "是": "Sì",
  "否": "No",
  "库存数量": "Quantità d'Inventario",
  "请填写库存数量": "Si prega di compilare la quantità in magazzino",
  "请上传分类图片": "Si prega di caricare l'immagine della categoria",
  "发布": "Pubblica",
  "级": "Livello",
  "请填写口味": "Si prega di inserire il gusto",
  "从AI图库搜索": "Cerca nell'Archivio Immagini AI",
  "AI获取标签": "AI Ottiene Tag",
  "标签": "Tag",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "I tag aggiunti possono aiutare l'assistente per ordinazioni AI a comprendere più precisamente le esigenze di ordinazione del cliente",
  "同步至店内": "Sincronizza con il Negozio",
  "是否同步商品至外卖": "Se sincronizzare i prodotti con il servizio da asporto",
  "是否同步商品至店内": "Se sincronizzare i prodotti con il negozio",
  "付款减库存": "Pagamento per Ridurre l'Inventario",
  "菜品录入使用语言": "Lingua Utilizzata per l'Inserimento del Piatto",
  "网站主页": "Homepage del Sito Web",
  "主题编辑": "Modifica del Tema",
  "我的菜单": "Il Mio Menu",
  "添加菜单": "Aggiungi Menu",
  "菜单名称": "Nome del Menu",
  "图标": "Icona",
  "是否显示": "Se Mostrare",
  "更新时间": "Data di Aggiornamento",
  "正在处理": "In Elaborazione",
  "处理失败，请重试": "Elaborazione Fallita, Si Prega di Riprovare",
  "此操作将永久删除该记录, 是否继续?": "Questa operazione eliminerà permanentemente questo record, vuoi continuare?",
  "确定": "Confermare",
  "主题选择": "Selezione del Tema",
  "主题一": "Tema Uno",
  "主题二": "Tema Due",
  "主题三": "Tema Tre",
  "主题四": "Tema Quattro",
  "主题五": "Tema Cinque",
  "主题六": "Tema Sei",
  "主页预览": "Anteprima della Homepage",
  "撤回": "Ritirare",
  "获取预览网站失败,请检查网络或联系管理员": "Impossibile ottenere il sito di anteprima, controllare la rete o contattare l'amministratore",
  "撤回成功": "Ritiro Completato con Successo",
  "编辑菜单": "Modifica Menu",
  "请输入广告标题": "Per favore inserisci il titolo dell'annuncio",
  "图标大小为": "La Dimensione dell'Icona è",
  "显示": "Visualizzazione",
  "隐藏": "Nascondere",
  "请输入数字": "Per favore inserisci il numero",
  "链接": "Collegamento",
  "选择链接": "Scegli il Collegamento",
  "提交": "Invia",
  "请输入菜单名称": "Per favore inserisci il nome del menu",
  "请选择链接地址": "Per favore seleziona l'indirizzo del collegamento",
  "链接到": "Collegato a",
  "请上传图标": "Per favore carica l'icona",
  "确定要删除吗?": "Sei sicuro di voler eliminare?",
  "次浏览": "Visualizzato",
  "每日必拼": "Battaglia Quotidiana",
  "更多": "Di Più",
  "2人团": "Gruppo di 2 Persone",
  "去开团": "Vai Avanti con il Gruppo",
  "活动砍价": "Bargain dell'Attività",
  "已抢2件": "Già Acquistato 2 Pezzi",
  "立即砍价": "Bargain Ora",
  "满": "Pieno",
  "可用": "Disponibile",
  "立即领取": "Ricevi Ora",
  "热门直播": "Live Popolare",
  "已售": "Venduto",
  "限时秒杀": "Kill di Secondi a Tempo Limitato",
  "搜索商品": "Cerca Prodotti",
  "线下门店": "Negozio Fisico",
  "门店logo": "Logo del Negozio",
  "门店地址": "Indirizzo del Negozio",
  "您的浏览器不支持 video 标签": "Il Tuo Browser Non Supporta i Tag Video",
  "店家正在直播、折扣套餐秒杀中": "Il Proprietario del Negozio sta Trasmettendo in Diretta, Pacchetto Sconto Kill di Secondi",
  "进入": "Entra",
  "至少保留一个": "Mantieni almeno uno",
  "咨询分类": "Categoria di Consultazione",
  "全部分类": "Tutte le Categorie",
  "显示数量": "Quantità di Visualizzazione",
  "咨询数据请到": "I Dati di Consultazione si prega di andare a",
  "中管理": "Gestire in",
  "插件": "Plugin",
  "显示类型": "Tipo di Visualizzazione",
  "有图模式": "Modalità con Immagine",
  "无图模式": "Modalità Senza Immagine",
  "组件样式": "Stile Componente",
  "显示内容": "Contenuto Visualizzato",
  "拼团价格": "Prezzo della Battaglia di Gruppo",
  "划线价格": "Prezzo con Linea di Separazione",
  "指示点颜色": "Colore del Punto di Indicazione",
  "重置": "Ripristina",
  "切换时间": "Tempo di Cambio",
  "轮播图自动切换的间隔时间，单位：毫秒": "Tempo di Intervallo per il Cambiamento Automatico dell'Immagine del Carosello, Unità: Millisecondi",
  "建议尺寸": "Dimensione Consigliata",
  "链接地址": "Indirizzo del Collegamento",
  "添加一个": "Aggiungi Uno",
  "标题内容": "Contenuto del Titolo",
  "文字内容": "Contenuto del Testo",
  "链接名称": "Nome del Collegamento",
  "正在砍价": "Bargaining",
  "商品原价": "Prezzo Originale delle Merci",
  "背景颜色": "Colore di Sfondo",
  "组件高度": "Altezza del Componente",
  "上下边距": "Margine Superiore e Inferiore",
  "线条样式": "Stile della Linea",
  "实线": "Linea Continua",
  "虚线": "Linea Tratteggiata",
  "点状": "A Punti",
  "线条颜色": "Colore della Linea",
  "线条高度": "Altezza della Linea",
  "左右边距": "Margine Sinistro e Destro",
  "标题": "Titolo",
  "颜色": "Colore",
  "每行数量": "Numero per Fila",
  "1个": "1 Pezzo",
  "2个": "2 Pezzi",
  "文字颜色": "Colore del Testo",
  "公告图标": "Icona dell'Annuncio",
  "公告内容": "Contenuto dell'Annuncio",
  "商品来源": "Fonte del Prodotto",
  "自动获取": "Acquisizione Automatica",
  "手动选择": "Selezione Manuale",
  "综合": "Comprehensive",
  "商品列表": "Elenco Prodotti",
  "选择产品": "Scegli il Prodotto",
  "列表平铺": "Pavimentazione dell'Elenco",
  "横向滑动": "Scorrimento Orizzontale",
  "分列数量": "Numero di Colonne",
  "单列": "Colonna Singola",
  "两列": "Due Colonne",
  "三列": "Tre Colonne",
  "商品价格": "Prezzo del Prodotto",
  "商品销量": "Vendite del Prodotto",
  "提示文字": "Testo di Avviso",
  "搜索框样式": "Stile della Casella di Ricerca",
  "方形": "Quadrato",
  "圆角": "Angoli Arrotondati",
  "圆弧": "Arco",
  "文字对齐": "Allineamento del Testo",
  "居左": "Sinistra",
  "居中": "Centro",
  "居右": "Destra",
  "秒杀价格": "Prezzo Kill di Secondi",
  "底边距": "Margine Inferiore",
  "右边距": "Margine Destro",
  "不透明度": "Opacità",
  "客服类型": "Tipo di Servizio Clienti",
  "在线聊天": "Chat Online",
  "拨打电话": "Chiamare",
  "电话号码": "Numero di Telefono",
  "客服图标": "Icona del Servizio Clienti",
  "标题类型": "Tipo di Titolo",
  "页面名称": "Nome della Pagina",
  "页面名称仅用于后台查找": "Il Nome della Pagina è Utilizzato Solo per la Ricerca Backend",
  "分享标题": "Titolo della Condivisione",
  "小程序端转发时显示的标题": "Titolo Visualizzato Quando il Mini Programma Viene Inoltrato",
  "文章分类": "Categoria dell'Articolo",
  "文章数据请到": "I Dati dell'Articolo si prega di andare a",
  "内容管理": "Gestione del Contenuto",
  "文章列表": "Elenco degli Articoli",
  "单行": "Riga Singola",
  "两行": "Due Righe",
  "门店列表": "Elenco dei Negozi",
  "选择门店": "Scegli il Negozio",
  "展示数量": "Quantità Visualizzata",
  "视频高度": "Altezza del Video",
  "滑块可用左右方向键精确调整": "Lo Slider Può Essere Regolato con Precisione con i Tasti Freccia Sinistra e Destra",
  "视频封面": "Copertina del Video",
  "视频地址": "Indirizzo Video",
  "自动播放": "Riproduzione Automatica",
  "布局方式": "Metodo di Layout",
  "堆积两列": "Stack due Colonne",
  "堆积三列": "Stack tre Colonne",
  "堆积四列": "Stack quattro Colonne",
  "橱窗样式": "Stile Vetrina",
  "橱窗样式最多显示四张图片，超出隐藏": "Lo Stile Vetrina Mostra al Massimo Quattro Immagini, Nascoste se Superate",
  "请确保所有图片的尺寸/比例相同": "Per favore assicurati che tutte le immagini abbiano le stesse dimensioni/proporzioni",
  "标题文字": "Testo del Titolo",
  "组件库": "Biblioteca Componenti",
  "媒体组件": "Componente Multimediale",
  "商城组件": "Componente del Centro Commerciale",
  "工具组件": "Componente di Strumento",
  "登录组件": "Componente di Accesso",
  "资讯管理": "Gestione delle Informazioni",
  "添加资讯": "Aggiungi Informazioni",
  "资讯ID": "ID dell'Informazione",
  "封面": "Copertina",
  "资讯标题": "Titolo dell'Informazione",
  "虚拟阅读量": "Volume di Lettura Virtuale",
  "实际阅读量": "Volume di Lettura Effettivo",
  "资讯排序": "Ordinamento dell'Informazione",
  "已取消删除": "Cancellazione Annullata",
  "请输入文章标题": "Per favore inserisci il titolo dell'articolo",
  "描述": "Descrizione",
  "请输入文章描述": "Per favore inserisci la descrizione dell'articolo",
  "缩略图": "Miniatura",
  "资讯分类": "Categoria dell'Informazione",
  "资讯状态": "Stato dell'Informazione",
  "资讯内容": "Contenuto dell'Informazione",
  "分类ID": "ID Categoria",
  "编辑分类": "Modifica Categoria",
  "恭喜你，修改成功": "Congratulazioni, Modifica Riuscita",
  "编辑资讯": "Modifica Informazione",
  "份": "Porzione",
  "中文": "Cinese",
  "英语": "Inglese",
  "意大利语": "Italiano",
  "德语": "Tedesco",
  "西班牙语": "Spagnolo",
  "法语": "Francese",
  "克罗地亚": "Croato",
  "斯洛文尼亚": "Sloveno",
  "匈牙利语": "Ungherese",
  "规格库": "Biblioteca delle Specifiche",
  "属性库": "Biblioteca degli Attributi",
  "加料库": "Biblioteca Aggiuntiva di Materiali",
  "规格名": "Nome della Specifica",
  "批量删除": "Eliminazione di Massa",
  "请输入规格名称": "Per favore inserisci il nome della specifica",
  "删除后不可恢复，确认删除吗?": "Non può essere ripristinato dopo l'eliminazione, confermare l'eliminazione?",
  "属性名": "Nome dell'Attributo",
  "请输入属性名称": "Per favore inserisci il nome dell'attributo",
  "请输入属性值": "Per favore inserisci il valore dell'attributo",
  "添加属性名": "Aggiungi Nome dell'Attributo",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Panoramica in Tempo Reale",
  "营业总额": "Fatturato Totale",
  "有效订单": "Ordini Validi",
  "退款金额": "Importo del Rimborso",
  "销量排行榜": "Classifica delle Vendite",
  "销售额排行榜": "Classifica dell'Importo delle Vendite",
  "订单号": "Numero dell'Ordine",
  "请输入订单号": "Si Prega di Inserire il Numero dell'Ordine",
  "配送方式": "Metodo di Consegna",
  "起始时间": "Orario di Inizio",
  "开始日期": "Data di Inizio",
  "结束日期": "Data di Fine",
  "导出": "Esporta",
  "全部订单": "Tutti gli Ordini",
  "未付款": "Non Pagato",
  "进行中": "In Corso",
  "已取消": "Annullato",
  "已完成": "Completato",
  "订单信息": "Informazioni sull'Ordine",
  "下单时间": "Orario dell'Ordine",
  "取消申请中": "Richiesta di Annullamento in Corso",
  "实付款": "Pagamento Effettivo",
  "含服务费": "Inclusa la Tassa di Servizio",
  "含包装费": "Inclusa la Tassa di Imballaggio",
  "买家": "Acquirente",
  "出餐状态": "Stato del Servizio",
  "准备中": "In Preparazione",
  "出餐中": "In Cottura",
  "待取餐": "In Attesa per il Ritiro",
  "交易状态": "Stato della Transazione",
  "支付方式": "Metodo di Pagamento",
  "订单详情": "Dettagli dell'Ordine",
  "出餐": "Servire il Pasto",
  "退款": "Rimborso",
  "核销": "Verifica",
  "确定要出餐吗?": "Sei Sicuro di Voler Servire il Pasto?",
  "确定要核销吗?": "Sei Sicuro di Voler Verificare?",
  "恭喜你，操作成功": "Congratulazioni, Operazione Riuscita",
  "已取消核销": "Verifica Annullata",
  "订单来源": "Origine dell'Ordine",
  "用户": "Utente",
  "订单金额": "Importo dell'Ordine",
  "配送费": "Tassa di Consegna",
  "服务费": "Tassa di Servizio",
  "优惠券抵扣": "Deduzione del Coupon",
  "积分抵扣": "Deduzione Punti",
  "满减金额": "Importo Scontato",
  "优惠金额": "Importo dello Sconto",
  "实付款金额": "Importo Effettivo del Pagamento",
  "用餐方式": "Metodo di Consumo",
  "取餐时间": "Orario di Ritiro",
  "桌号": "Numero del Tavolo",
  "修改价格": "Modifica Prezzo",
  "门店信息": "Informazioni del Negozio",
  "商品信息": "Informazioni sul Prodotto",
  "会员折扣价": "Prezzo con Sconto per Socio",
  "购买数量": "Quantità Acquistata",
  "商品总价": "Prezzo Totale del Prodotto",
  "收货信息": "Informazioni di Ricezione",
  "收货人": "Destinatario",
  "收货电话": "Telefono del Destinatario",
  "收货地址": "Indirizzo di Ricezione",
  "备注": "Nota",
  "自提用户信息": "Informazioni Utente per il Ritiro",
  "用户信息": "Informazioni Utente",
  "联系手机": "Cellulare di Contatto",
  "付款信息": "Informazioni di Pagamento",
  "应付款金额": "Importo Dovuto",
  "支付流水号": "Numero di Serie del Pagamento",
  "付款状态": "Stato di Pagamento",
  "付款时间": "Orario di Pagamento",
  "发货信息": "Informazioni di Spedizione",
  "发货状态": "Stato di Spedizione",
  "取消信息": "Informazioni di Annullamento",
  "商家备注": "Nota del Venditore",
  "门店自提核销": "Verifica per il Ritiro in Negozio",
  "核销员": "Verificatore",
  "核销状态": "Stato di Verifica",
  "已核销": "Verificato",
  "核销时间": "Orario di Verifica",
  "返回上一页": "Torna alla Pagina Precedente",
  "确认发货": "Conferma Spedizione",
  "确认审核": "Conferma Revisione",
  "请选择物流公司": "Si Prega di Selezionare la Compagnia Logistica",
  "请填写物流单号": "Si Prega di Inserire il Numero di Tracciabilità Logistica",
  "恭喜你，发货成功": "Congratulazioni, Spedizione Riuscita",
  "恭喜你，审核成功": "Congratulazioni, Revisione Riuscita",
  "订单价格修改": "Modifica del Prezzo dell'Ordine",
  "运费金额": "Importo della Spedizione",
  "最终付款价": "Prezzo Finale da Pagare",
  "取消订单": "Annulla Ordine",
  "请输入备注": "Si Prega di Inserire una Nota",
  "请输入退款金额": "Si Prega di Inserire l'Importo del Rimborso",
  "确认退款?": "Confermare il Rimborso?",
  "已取消退款": "Rimborso Annullato",
  "含配送费": "Con Tassa di Consegna",
  "确认送达": "Conferma di Arrivo",
  "是否确认此操作?": "Confermare questa Operazione?",
  "配送状态": "Stato di Consegna",
  "备注信息": "Informazioni sulla Nota",
  "期望配送时间": "Tempo di Consegna Previsto",
  "订单状态": "Stato dell'Ordine",
  "骑手姓名": "Nome del Corriere",
  "骑手电话": "Telefono del Corriere",
  "操作时间": "Orario dell'Operazione",
  "详情": "Dettagli",
  "此操作将确认送达, 是否继续?": "Questa Operazione Confermerà il Consegna, Vuoi Continuare?",
  "配送时间": "Orario di Consegna",
  "配送信息": "Informazioni di Consegna",
  "配送类型": "Tipo di Consegna",
  "配送距离": "Distanza di Consegna",
  "配送员": "Corriere di Consegna",
  "配送电话": "Telefono di Consegna",
  "配送费用": "Costi di Consegna",
  "送达时间": "Orario di Arrivo",
  "取消原因": "Motivo dell'Annullamento",
  "请输入取消原因": "Si Prega di Inserire il Motivo dell'Annullamento",
  "米": "Metro",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "ID Negozio",
  "联系地址": "Indirizzo di Contatto",
  "下载二维码": "Scarica Codice QR",
  "H5网页": "Pagina Web H5",
  "添加门店": "Incorpora Struttura",
  "设置": "Configurazione",
  "恭喜你，门店删除成功": "Congratulazioni, Eliminazione Negozio Riuscita",
  "请输入地点": "Si Prega di Inserire la Posizione",
  "添加": "Incorpora",
  "等级": "Grado",
  "请选择会员等级": "Si Prega di Selezionare il Grado di Associazione",
  "性别": "Sesso",
  "请选择性别": "Si Prega di Selezionare il Sesso",
  "微信昵称": "Nome Utente WeChat",
  "请输入微信昵称": "Si Prega di Inserire il Nome Utente WeChat",
  "微信头像": "Immagine del Profilo WeChat",
  "昵称": "Soprannome",
  "用户余额": "Saldo Utente",
  "累积消费金额": "Importo di Consumo Cumulativo",
  "注册时间": "Orario di Registrazione",
  "分钟后自动清理桌台": "Pulizia Automatica dei Tavoli Dopo Minuti",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Orario Pianificato per la Pulizia dei Tavoli Dopo la Scansione dei Codici per l'Ordinazione e i Tavoli della Cassa",
  "到店自提": "Ritiro in Negozio",
  "打包带走": "Asporto",
  "店内就餐": "Consumo in Sede",
  "外卖配送至少选择一种！": "Scegli almeno un Metodo di Consegna per l'Asporto!",
  "店内配置至少选择一种！": "Scegli almeno una Configurazione in Sede!",
  "恭喜你，设置成功": "Congratulazioni, Configurazione Riuscita",
  "恭喜你，门店修改成功": "Congratulazioni, Modifica Negozio Riuscita",
  "门店": "Negozio",
  "提现金额": "Importo Prelievo",
  "打款方式": "Metodo di Pagamento",
  "待审核": "In Attesa di Revisione",
  "审核通过": "Approvato",
  "驳回": "Respinto",
  "原因": "Motivo",
  "已打款": "Pagamento Effettuato",
  "审核": "Revisione",
  "确认打款": "Conferma Pagamento",
  "确认要打款吗?": "Confermare il Pagamento?",
  "供应商名称": "Nome Fornitore",
  "余额变动场景": "Scenari di Variazione del Saldo",
  "收入": "Entrate",
  "提现": "Prelievo",
  "起始日期": "Data d'Inizio",
  "变动金额": "Importo Modificato",
  "描述/说明": "Descrizione/Spiegazione",
  "创建时间": "Orario di Creazione",
  "恭喜你，门店添加成功": "Congratulazioni, Aggiunta Negozio Riuscita",
  "驳回原因": "Motivo del Rifiuto",
  "提现审核": "Revisione Prelievo",
  "小票打印设置": "Impostazione Stampa Scontrino",
  "是否开启商户小票打印": "Abilita la Stampa Scontrino Commerciale",
  "选择打印机": "Seleziona Stampante",
  "是否开启顾客小票打印": "Abilita la Stampa Scontrino Cliente",
  "选择打印机二": "Seleziona Stampante Due",
  "是否开启厨房小票打印": "Abilita la Stampa Scontrino Cucina",
  "选择打印机三": "Seleziona Stampante Tre",
  "恭喜你，打印设置成功": "Congratulazioni, Impostazione Stampa Riuscita",
  "小票打印机列表": "Elenco Stampanti Scontrini",
  "打印机ID": "ID Stampante",
  "打印机名称": "Nome Stampante",
  "编辑小票打印机": "Modifica Stampante Scontrino",
  "打印机类型": "Tipo di Stampante",
  "米泰打印机": "Stampante Mettai",
  "打印机编号": "Numero di Serie Stampante",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "Il numero di serie della stampante è composto da 9 cifre, controlla il numero sull'adesivo nella parte inferiore della stampante Mettai",
  "打印机秘钥": "Chiave della Stampante",
  "打印联数": "Copie di Stampa",
  "同一订单，打印的次数": "Numero di Stampe per lo Stesso Ordine",
  "排序": "Ordinamento",
  "数字越小越靠前": "Un Numero Minore Indica una Priorità Maggiore",
  "新增小票打印机": "Aggiungi Nuova Stampante Scontrino",
  "恭喜你，添加成功": "Congratulazioni, Aggiunta Riuscita",
  "配送方式设置": "Impostazione Metodo di Consegna",
  "商家配送": "Consegna Commerciale",
  "自动配送时间(分钟)": "Tempo di Consegna Automatica (minuti)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Impostare su 0 per disabilitare la consegna automatica. Dopo l'ordinazione senza consegna, la consegna automatica verrà avviata dopo il tempo impostato",
  "商户编号": "ID Commerciante",
  "门店编号": "ID Negozio",
  "环境": "Ambiente",
  "测试环境": "Ambiente di Test",
  "正式环境": "Ambiente di Produzione",
  "回调地址": "Indirizzo di Ritorno",
  "运营城市": "Città Operativa",
  "恭喜你，上传设置成功": "Congratulazioni, Impostazione Upload Riuscita",
  "菜品打印列表": "Lista di Stampa Piatto",
  "名称": "Nome",
  "打印类型": "Tipo di Stampa",
  "外卖": "Asporto",
  "店内": "Consumazione in Sede",
  "菜品打印": "Stampa Piatto",
  "是否开启": "Abilita",
  "配送打印": "Stampa Consegna",
  "店内打印": "Stampa in Sede",
  "打印方式": "Metodo di Stampa",
  "付款打印": "Stampa Pagamento",
  "下单打印": "Stampa Ordine",
  "商品分组": "Gruppo di Prodotti",
  "男": "Uomo",
  "女": "Donna",
  "未知": "Sconosciuto",
  "文件管理": "Gestione File",
  "移动至": "Sposta in",
  "点击上传": "Fai clic per Caricare",
  "删除失败": "Eliminazione Fallita",
  "请选择文件": "Si Prega di Selezionare un File",
  "确定移动选中的文件吗？, 是否继续?": "Sei sicuro di voler spostare i file selezionati? Vuoi continuare?",
  "只能上传图片！": "Puoi Caricare Solo Immagini!",
  "上传文件只能是图片格式!": "Il File Caricato Deve Essere in Formato Immagine!",
  "上传文件大小不能超过 2MB!": "Le Dimensioni del File Caricato non Possono Superare i 2MB!",
  "请查看/裁切其它上传图片!": "Si Prega di Visualizzare/Ritagliare Altre Immagini Caricate!",
  "图片上传中,请等待": "Caricamento Immagine in Corso, Attendere Prego",
  "当前图片上传失败!": "Caricamento Immagine Attuale Fallito!",
  "本次上传图片失败": "Caricamento Immagine Fallito Questa Volta",
  "本次最多只能上传1个文件": "Puoi Caricare al Massimo 1 File Questa Volta",
  "裁剪图片": "Taglia Immagine",
  "选择优惠券": "Scegli Coupon",
  "数量": "Quantità",
  "无限制": "Senza Limiti",
  "请输入等级名称": "Si Prega di Inserire il Nome del Grado",
  "长度在3到5个字符": "La Lunghezza deve Essere tra 3 e 5 Caratteri",
  "错了哦，这是一条错误消息": "Ops, Questo è un Messaggio di Errore",
  "增加税率": "Aggiungi Aliquota Fiscale",
  "税率分类": "Categoria Aliquota Fiscale",
  "请输入税率分类": "Si Prega di Inserire la Categoria dell'Aliquota Fiscale",
  "自定义税率分类": "Categoria Aliquota Fiscale Personalizzata",
  "请输入税率值": "Si Prega di Inserire il Valore dell'Aliquota Fiscale",
  "单位是": "L'Unità è",
  "适用菜品分类": "Categoria Piatto Applicabile",
  "请选择菜品分类": "Si Prega di Selezionare la Categoria di Piatto",
  "修改税率信息": "Modifica Informazioni Aliquota Fiscale",
  "分类名称不能为空": "Il Nome della Categoria non Deve Essere Vuoto",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Gestione dei Membri",
  "等级管理": "Gestione del Livello",
  "余额明细": "Dettagli del Saldo",
  "请输入昵称": "Si prega di inserire il soprannome",
  "邮箱": "Email",
  "请输入邮箱地址": "Si prega di inserire l'indirizzo email",
  "无等级": "Nessun Livello",
  "余额": "Saldo",
  "积分": "Punti",
  "生日": "Compleanno",
  "充值": "Ricarica",
  "恭喜你，用户删除成功": "Congratulazioni, utente eliminato",
  "请选择等级": "Si prega di selezionare il livello",
  "管理员备注": "Note Amministratore",
  "请输入管理员备注": "Si prega di inserire le annotazioni amministrative",
  "恭喜你，用户修改成功": "Congratulazioni, modifica utente riuscita",
  "会员充值": "Ricarica Membri",
  "充值余额": "Importo Ricarica",
  "当前余额": "Saldo Attuale",
  "充值方式": "Metodo di Ricarica",
  "增加": "Aumenta",
  "减少": "Diminuisci",
  "最终金额": "Importo Finale",
  "变更金额": "Importo Modificato",
  "请输入变更金额": "Si prega di inserire l'importo modificato",
  "添加等级": "Aggiungi Livello",
  "等级名称": "Nome del Livello",
  "权重": "Peso",
  "升级条件": "Condizioni di Upgrade",
  "等级权重": "Peso del Livello",
  "请输入等级权重": "Si prega di inserire il peso del livello",
  "权重越大，等级越高": "Più alto è il peso, più alto è il livello",
  "等级折扣": "Sconto del Livello",
  "请输入等级折扣": "Si prega di inserire lo sconto del livello",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Soddisfare una delle condizioni selezionate di seguito comporterà un upgrade automatico del membro a quel livello",
  "累计消费满": "Spesa cumulativa raggiunge",
  "编辑等级": "Modifica Livello",
  "累计积分满": "Punti cumulativi raggiungono",
  "推荐人数满": "Numero di raccomandazioni raggiunge",
  "恭喜你，等级修改成功": "Congratulazioni, modifica livello riuscita",
  "个": "pezzi",
  "充值设置": "Impostazioni Ricarica",
  "是否开启余额充值": "Abilita la ricarica del saldo",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Nota: Se abilitato, il pulsante di ricarica verrà visualizzato sul dispositivo mobile; se il mini-programma non supera la revisione delle qualifiche, può rimanere disabilitato",
  "是否开启自定义金额": "Abilita l'importo personalizzato",
  "注：如开启则用户可以填写充值金额": "Nota: Se abilitato, gli utenti possono inserire un importo di ricarica personalizzato",
  "最低充值金额": "Importo minimo di ricarica",
  "注：自定义充值金额最低充值多少€": "Nota: Qual è l'importo minimo di ricarica per gli importi di ricarica personalizzati?",
  "充值说明": "Istruzioni Ricarica",
  "充值套餐": "Pacchetti Ricarica",
  "支付金额": "Importo Pagato",
  "到账数量": "Quantità Ricevuta",
  "充值时间": "Orario Ricarica",
  "到账金额": "Importo Ricevuto",
  "赠送金额": "Importo Regalato",
  "提现设置": "Impostazioni Prelievo",
  "是否开启提现": "Abilita i prelievi",
  "注：如开启则移动端显示 l'opzione Prelievo Saldo": "Nota: Se abilitato, il dispositivo mobile visualizzerà l'opzione Prelievo Saldo",
  "提现比例": "Percentuale Prelievo",
  "注：提现比例请填写数字0~100": "Nota: Si prega di inserire una percentuale di prelievo tra 0 e 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Esempio: Importo Prelievo ($100) * Percentuale Prelievo (100%) = Importo Ricevuto Effettivo (€100)",
  "最低提现金额": "Importo Minimo Prelievo",
  "注：最低提现金额多少元": "Nota: Qual è l'importo minimo di prelievo in yuan?",
  "请选择状态": "Si prega di selezionare lo stato",
  "提现方式": "Metodo di Prelievo",
  "请选择提现方式": "Si prega di selezionare un metodo di prelievo",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Carta Bancaria",
  "请输入用户ID": "Si prega di inserire l'ID utente",
  "请输入昵称/姓名/手机号": "Si prega di inserire nickname/nome/numero di cellulare",
  "提现信息": "Informazioni Prelievo",
  "支付宝名称": "Nome Alipay",
  "支付宝账号": "Account Alipay",
  "银行名称": "Nome Banca",
  "开户名": "Nome dell'Account",
  "银行卡号": "Numero di Carta Bancaria",
  "申请时间": "Orario Richiesta",
  "审核时间": "Orario Revisione",
  "微信付款": "Pagamento WeChat",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Questa operazione utilizzerà la funzione di pagamento aziendale di WeChat per trasferire sul portafoglio. Sei sicuro di voler procedere?",
  "添加充值套餐": "Aggiungi Pacchetto Ricarica",
  "套餐名称": "Nome del Pacchetto",
  "请输入套餐名称": "Si prega di inserire il nome del pacchetto",
  "请输入支付金额": "Si prega di inserire l'importo da pagare",
  "请输入赠送金额": "Si prega di fornire l'importo del regalo",
  "请输入到账金额": "Si prega di specificare l'importo accreditato",
  "请输入排序": "Si prega di inserire l'ordine di classificazione",
  "用户ID": "Identificazione Utente",
  "会员卡管理": "Gestione delle Carte dei Membri",
  "领取记录": "Registri di Ricezione",
  "删除记录": "Elimina Registro",
  "请输入关键词": "Si prega di inserire la parola chiave",
  "过期": "Scaduto",
  "有效": "Valido",
  "客户信息": "Informazioni Cliente",
  "会员卡名称": "Nome della Carta dei Membri",
  "有效期": "Periodo di Validità",
  "折": "Sconto",
  "领取时间": "Orario di Ricezione",
  "延期": "Posticipare",
  "撤销": "Revocare",
  "添加会员卡": "Aggiungi Carta dei Membri",
  "启用": "Attiva",
  "月": "Mese",
  "永久有效": "Valido per Sempre",
  "领取数量": "Quantità Ricevuta",
  "发卡": "Emit Card",
  "领取设置": "Impostazioni di Ricezione",
  "请检查必填项是否填写完整": "Si prega di verificare se i campi obbligatori sono completati",
  "领取人数": "Numero di Riceventi",
  "删除时间": "Orario di Eliminazione",
  "请填写有效期": "Si prega di compilare il periodo di validità",
  "有效期限（月），0为永久有效": "Periodo di validità (in mesi), 0 per validità indefinita",
  "请填写价格": "Si prega di fornire il prezzo",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "L'importo che gli utenti devono pagare per l'acquisto della carta dei membri, 0 per il rilascio gratuito",
  "使用须知": "Linee Guida d'Uso",
  "请填写使用须知": "Si prega di fornire le istruzioni d'uso",
  "请填写会员卡名称": "Si prega di inserire il nome della carta dei membri",
  "卡片类型": "Tipo di Carta",
  "卡片样式": "Stile della Carta",
  "请填写排序": "Si prega di inserire l'ordine di classificazione",
  "会员权益": "Benefici dei Membri",
  "无折扣": "Nessuno Sconto",
  "请填写折扣": "Si prega di inserire lo sconto",
  "开卡赠送": "Regalo all'Attivazione della Carta",
  "优惠券": "Coupon",
  "请填写积分数量": "Si prega di specificare la quantità di punti",
  "请填写余额数量": "Si prega di fornire l'importo del saldo",
  "请填写优惠券": "Si prega di inserire il coupon",
  "添加优惠券": "Aggiungi Coupon",
  "券名称": "Nome del Coupon",
  "每人领取数量": "Quantità per Persona",
  "选择优惠券弹出层": "Selezione Pop-up Coupon",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Hai già selezionato quindici coupon, elimina gli altri se vuoi sostituirli!",
  "产品编码": "Codice Prodotto",
  "请填写产品编码": "Si prega di compilare il codice prodotto",
  "产品划线价": "Prezzo di Listino del Prodotto",
  "请填写产品划线价": "Si prega di fornire il prezzo di listino del prodotto",
  "商品重量": "Peso del Prodotto",
  "请填写商品重量": "Si prega di fornire il peso del prodotto",
  "批量设置": "Impostazioni di Massa",
  "划线价": "Prezzo di Listino",
  "重量": "Peso",
  "应用": "Applica",
  "规格图片": "Immagine delle Specifiche",
  "规格值": "Valore delle Specifiche",
  "请输入规格值": "Si prega di inserire il valore delle specifiche",
  "请填写规则名或规则值": "Si prega di inserire il nome della regola o il valore della regola",
  "规格值不能为空": "Il valore delle specifiche non può essere vuoto",
  "卡名称": "Nome della Carta",
  "卡ID": "Identificazione Carta",
  "无": "Nessuno",
  "选择会员": "Seleziona Membro",
  "恭喜你，发卡成功": "Congratulazioni, emissione della carta riuscita",
  "副卡数": "Numero di Carte Supplementari",
  "张": "pezzi",
  "选择日期": "Seleziona Data",
  "签到设置": "Impostazioni del Check-in",
  "签到记录": "Registri del Check-in",
  "是否开启签到有礼": "Abilita i Premi del Check-in",
  "每日签到固定奖励": "Ricompensa Fissa per il Check-in Giornaliero",
  "每日签到送": "Ricompensa per il Check-in Giornaliero",
  "递增奖励": "Ricompensa Incrementale",
  "有": "Sì",
  "第二天起递增奖励": "Ricompensa Incrementale a Partire dal Secondo Giorno",
  "请输入第二天起递增积分数": "Si prega di inserire i punti incrementali a partire dal secondo giorno",
  "第": "Giorno",
  "请输入第几天不再递增": "Inserire il giorno in cui cessa l'incremento",
  "天起不再递增": "Niente più incremento da questo giorno in poi",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Premi Extra per i Check-in Continuativi (Raggiunto il massimo dei giorni di premio extra, ulteriori check-in non riceveranno premi extra; il conteggio riprende dopo aver saltato un check-in)",
  "额外奖励": "Ricompensa Aggiuntiva",
  "连续签到": "Check-in Consecutivo",
  "请输入连续签到天数": "Si prega di inserire il numero di giorni consecutivi di check-in",
  "积分奖励": "Premi Punti",
  "送": "regalo",
  "请输入连续签到天数的积分": "Si prega di specificare i punti per i giorni di check-in consecutivi",
  "规则": "Regole",
  "规则说明": "Spiegazione delle Regole",
  "请添加至少一项额外奖励！": "Si prega di aggiungere almeno un premio extra!",
  "天数不能为空！": "I giorni non possono essere vuoti!",
  "请输入连续签到积分数！": "Si prega di inserire i punti per i check-in consecutivi!",
  "每日签到送积分有误": "Errore nei punti di ricompensa del check-in giornaliero",
  "恭喜你，保存成功": "Congratulazioni, salvataggio riuscito",
  "连续签到天数": "Giorni di Check-in Consecutivi",
  "不限": "Illimitato",
  "签到时间": "Orario del Check-in",
  "时间": "Tempo",
  "请输入用户昵称": "Si prega di inserire il nickname dell'utente",
  "签到日期": "Data del Check-in",
  "活动奖品": "Premi dell'Attività",
  "取号记录": "Registri della Prenotazione del Numero",
  "桌号管理": "Gestione dei Tavoli",
  "取号设置": "Impostazioni di Prenotazione del Numero",
  "请输入手机号": "Si prega di inserire il numero di telefono",
  "待叫号": "Da Chiamare",
  "已入座": "Seduto",
  "已过号": "Mancato",
  "就餐号": "Numero di Coperti",
  "就餐人数": "Numero di Commensali",
  "桌位名称": "Nome del Tavolo",
  "取号时间": "Orario di Prenotazione del Numero",
  "待取号": "In Attesa di Prenotazione",
  "是否开启打印": "Abilita la Stampa",
  "须知": "Istruzioni",
  "请输入须知": "Si prega di inserire le istruzioni",
  "商家说明": "Descrizione del Commerciante",
  "请输入商家说明": "Si prega di fornire la descrizione del commerciante",
  "取号规则": "Regole di Prenotazione del Numero",
  "等待时间": "Tempo di Attesa",
  "人数最小值": "Numero Minimo di Persone",
  "人数最大值": "Numero Massimo di Persone",
  "等待时间(分钟)": "Tempo di Attesa (minuti)",
  "请输入桌位名称": "Si prega di inserire il nome del tavolo",
  "请输入人数最小值": "Si prega di specificare il numero minimo di persone",
  "请输入人数最大值": "Si prega di specificare il numero massimo di persone",
  "请输入等待时间": "Si prega di inserire il tempo di attesa",
  "商品设置": "Impostazioni del Prodotto",
  "兑换记录": "Registri di Scambio",
  "活动名称": "Nome dell'Attività",
  "请输入活动名称": "Si prega di inserire il nome dell'attività",
  "活动列表": "Lista delle Attività",
  "添加活动": "Aggiungi Attività",
  "活动价格": "Prezzo dell'Attività",
  "发放数量": "Quantità di Distribuzione",
  "参与人数": "Numero di Partecipanti",
  "终止": "Termina",
  "购买记录": "Registri di Acquisto",
  "新增活动会场": "Aggiungi Nuova Area dell'Attività",
  "活动标题": "Titolo dell'Attività",
  "请输入活动标题": "Si prega di inserire il titolo dell'attività",
  "活动日期": "Data dell'Attività",
  "礼包设置": "Configurazione del Pacchetto Regalo",
  "优惠券id": "ID del Coupon",
  "购买设置": "Impostazioni di Acquisto",
  "购买金额": "Importo d'Acquisto",
  "会员购买等级": "Livello Acquisto Membro",
  "指定等级": "Livello Designato",
  "购买次数": "Frequenza di Acquisto",
  "限购": "Limite d'Acquisto",
  "每人限购": "Limite d'Acquisto per Persona",
  "次": "Volte",
  "发放设置": "Impostazioni di Distribuzione",
  "请输入发放数量": "Si prega di inserire la quantità di distribuzione",
  "返回": "Indietro",
  "请勿重复添加": "Si prega di evitare aggiunte duplicate",
  "至少选择一个优惠券": "Si prega di selezionare almeno un coupon",
  "新增活动": "Aggiungi Nuova Attività",
  "券包设置": "Impostazioni del Pacchetto Coupon",
  "下载推广码": "Scarica il Codice Promozionale",
  "下载类型": "Tipo di Download",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Prima di utilizzare questa funzione, è necessario andare all'area amministrativa del mini-programma, in ;;'Impostazioni'-'Impostazioni dell'Interfaccia" - "Componente di Follow dell'Account Pubblico,' impostare l'account pubblico da visualizzare. Nota: l'account pubblico impostato deve corrispondere all'entità del mini-programma",
  "去配置": "Vai alla Configurazione",
  "若没有配置公众号，功能将不生效": "Se non si configura un account pubblico, la funzione non sarà attiva",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Solo quando si accede al mini-programma dai seguenti scenari durante il suo ciclo di vita, sarà possibile attivare la capacità di visualizzazione e guida per seguire l'account pubblico",
  "当小程序从扫小程序码打开时": "Quando il mini-programma viene aperto scansionando il codice mini-programma",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Quando si torna al mini-programma da un altro mini-programma, se il mini-programma precedente non è stato distrutto, il componente manterrà lo stato dell'ultima apertura del mini-programma",
  "公众号关注": "Segui Account Pubblico",
  "新客设置": "Configurazione Nuovo Cliente",
  "是否开启活动": "L'attività è abilitata?",
  "活动时间": "Periodo dell'Attività",
  "背景图": "Immagine di Sfondo",
  "赠送优惠券": "Regalo del Coupon",
  "请选择优惠券": "Si prega di selezionare un coupon",
  "赠送积分": "Regalo dei Punti",
  "请输入赠送积分": "Si prega di inserire i punti da regalare",
  "直播同步": "Sincronizzazione della Diretta",
  "同步直播": "Sincronizza la Diretta",
  "请输入直播间名称/主播昵称": "Si prega di inserire il nome della stanza live/il nickname dell'host",
  "直播间ID": "ID della Stanza Live",
  "直播间名称": "Nome della Stanza Live",
  "主播昵称": "Nickname dell'Host",
  "直播开始时间": "Orario d'Inizio della Diretta",
  "直播结束时间": "Orario di Fine della Diretta",
  "直播间状态": "Stato della Stanza Live",
  "置顶": "Fissa in Alto",
  "未置顶": "Non Fissata in Alto",
  "已置顶": "Fissata in Alto",
  "设为置顶": "Imposta come Top",
  "取消置顶": "Annulla Fissaggio in Alto",
  "直播中": "In Diretta",
  "未开始": "Non Iniziato",
  "已结束": "Terminato",
  "禁播": "Bloccata",
  "暂停": "In Pausa",
  "异常": "Anomalia",
  "已过期": "Scaduto",
  "置顶成功": "Fissaggio in Alto Riuscito",
  "邀请活动": "Evento di Invito",
  "个人中心图片": "Immagine del Centro Personale",
  "请输入用户昵称/手机号": "Si prega di inserire il nickname dell'utente/il numero di telefono",
  "邀请人": "Invitante",
  "被邀请人": "Invitato",
  "参加时间": "Orario di Partecipazione",
  "个人中心显示": "Visualizzazione del Centro Personale",
  "参与记录": "Registri di Partecipazione",
  "礼品记录": "Registri dei Regali",
  "推广二维码": "Codice QR di Promozione",
  "编辑活动会场": "Modifica Area dell'Evento",
  "请输入分享标题": "Si prega di inserire il titolo della condivisione",
  "请输入分享内容": "Si prega di inserire il contenuto della condivisione",
  "分享内容": "Contenuto della Condivisione",
  "分享图": "Immagine di Condivisione",
  "个人中心状态": "Stato del Centro Personale",
  "邀请成功的条件": "Condizioni per l'Invito Riuscito",
  "邀请成为会员": "Invita a Diventare Membro",
  "邀请成为会员且消费": "Invita a Diventare Membro e Consumare",
  "礼品设置": "Impostazioni del Regalo",
  "奖项": "Premio",
  "每邀请": "Per Invito",
  "人获得礼品": "Riceve un Regalo",
  "添加奖励项": "Aggiungi Elemento di Ricompensa",
  "请上传背景图": "Si prega di caricare l'immagine di sfondo",
  "请上传分享图": "Si prega di caricare l'immagine di condivisione",
  "请添加奖项": "Si prega di aggiungere un premio",
  "开启首页推送": "Abilita la Promozione in Homepage",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Si consiglia di cambiare l'attività; il cambio di questo nome regolerà il pop-up sulla homepage del centro commerciale in base a questo nome",
  "类型": "Tipo",
  "图文": "Testo e Immagine",
  "纯图": "Solo Immagine",
  "领取优惠券": "Ricevi il Coupon",
  "请输入标题": "Si prega di inserire un titolo",
  "弹窗图片": "Immagine del Pop-up",
  "图片为2M以内大小，格式限png，jpg格式": "Le immagini devono avere una dimensione minore di 2 MB e devono essere in formato PNG o JPG",
  "按钮文案": "Testo del Pulsante",
  "简介说明": "Spiegazione Sintetica",
  "请输入说明": "Si prega di inserire una spiegazione",
  "点击选择你要链接的位置": "Fai clic per indicare il posizionamento del collegamento",
  "跳转地址": "Indirizzo di Reindirizzamento",
  "最多可以添加三张": "Massimo tre aggiunte Consentite",
  "最多添加3张优惠券": "Limite Massimo di Aggiunte: 3 Coupon",
  "标题不能为空": "Il Titolo non può essere Vuoto",
  "请选择跳转链接": "Seleziona il Link di Reindirizzamento",
  "请选择优惠卷": "Seleziona Coupon",
  "请上传图片": "Si prega di Caricare l'Immagine",
  "团购订单": "Ordini di Gruppo",
  "团购管理": "Gestione degli Acquisti di Gruppo",
  "团购设置": "Impostazioni Acquisto di Gruppo",
  "订单设置": "Impostazioni dell'Ordine",
  "未支付订单": "Ordini non Pagati",
  "请输入关闭时间": "Si prega di Inserire l'Ora di Chiusura",
  "分钟后自动关闭": "Chiusura Automatica Dopo Minuti",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Ordini Senza Pagamento si Chiudono Automaticamente Dopo n Minuti; Imposta a 0 per Nessuna Chiusura Automatica",
  "团购保障": "Garanzia Acquisto di Gruppo",
  "使用门店": "Utilizzo del Negozio",
  "待付款": "In Attesa di Pagamento",
  "待使用": "In Attesa di Utilizzo",
  "已退款": "Rimborsato",
  "使用门店名称": "Nome del Negozio per Utilizzo",
  "门店联系人": "Contatto del Negozio",
  "门店电话": "Numero di Telefono del Negozio",
  "团购信息": "Informazioni sull'Acquisto di Gruppo",
  "券码信息": "Informazioni sul Codice del Coupon",
  "核销券码": "Utilizza il Codice del Coupon",
  "添加团购": "Aggiungi Acquisto di Gruppo",
  "团购名称": "Nome dell'Acquisto di Gruppo",
  "销售价格": "Prezzo di Vendita",
  "虚拟销量": "Volume di Vendita Virtuale",
  "部分": "Parziale",
  "基础设置": "Configurazione di Base",
  "购买须知": "Linee Guida per l'Acquisto",
  "团购详情": "Dettagli dell'Acquisto di Gruppo",
  "团购须知": "Linee Guida per l'Acquisto di Gruppo",
  "请输入团购名称": "Inserisci il Nome dell'Acquisto di Gruppo",
  "到期类型": "Tipo di Scadenza",
  "购买后生效": "Validità Post Acquisto",
  "固定时间": "Orario Fisso",
  "有效天数": "Periodo di Validità in Giorni",
  "请输入有效天数": "Inserisci il Periodo di Validità in Giorni",
  "有效时间": "Orario di Validità",
  "请输入有效时间": "Inserisci l'Orario di Validità",
  "团购图片": "Immagine dell'Acquisto di Gruppo",
  "请上传团购图片": "Si prega di Caricare l'Immagine dell'Acquisto di Gruppo",
  "请输入划线价格": "Inserisci il Prezzo di Listino",
  "请输入销售价格": "Inserisci il Prezzo di Vendita",
  "请输入虚拟销量": "Inserisci il Volume di Vendita Virtuale",
  "适用门店": "Negozi Applicabili",
  "请选择门店": "Seleziona il Negozio",
  "团购状态": "Stato dell'Acquisto di Gruppo",
  "每日限购数量": "Limite di Acquisto Giornaliero",
  "每个会员每日购买的最大数量，0为不限购": "Limite Massimo di Acquisto Giornaliero per Ogni Membro; 0 per Nessun Limite",
  "商家名称": "Nome del Commerciante",
  "平台": "Piattaforma",
  "满类型": "Tipo di Soglia",
  "满额": "Ammontare Minimo",
  "满件数": "Quantità Minima",
  "满值": "Valore Minimo",
  "减类型": "Tipo di Decurtazione",
  "减金额": "Ammontare della Decurtazione",
  "打折": "Sconto",
  "减值": "Valore delle Decurtazioni",
  "编辑活动": "Modifica Attività",
  "满金额": "Ammontare Minimo",
  "请输入满值": "Inserisci il Valore Minimo",
  "如果是打折，填写80，表示打8折": "Se è uno Sconto, Inserisci 80 per il 20% di Sconto",
  "满额免配送费设置": "Spedizione Gratuita sull'Ammontare Minimo",
  "是否开启满额免配送费": "Abilita Spedizione Gratuita sull'Ammontare Minimo",
  "单笔订单满": "Ordine Singolo sopra",
  "如果开启满额免配送费，设置0为全场免配送费": "Se la Spedizione è Gratuita, Imposta 0 per Tutta l'Ordine",
  "入驻申请": "Domanda di Insediamento",
  "配送订单": "Ordini di Consegna",
  "提现申请": "Richiesta di Prelievo",
  "配送设置": "Impostazioni di Consegna",
  "退出申请": "Richiesta di Uscita",
  "正常": "Normale",
  "押金": "Deposito",
  "累计佣金": "Commissioni Accumulate",
  "可提现佣金": "Commissioni Disponibili per Prelievo",
  "已提现佣金": "Commissioni Già Prelievo",
  "提现明细": "Dettagli del Prelievo",
  "申请条件": "Condizioni di Domanda",
  "结算": "Liquidazione",
  "是否开启押金支付": "Abilita Pagamento del Deposito",
  "是否审核": "Richiede Revisione",
  "需后台审核": "Richiede Revisione dal Backend",
  "无需审核": "Nessuna Revisione Richiesta",
  "产品列表弹出层": "Popup della Lista Prodotti",
  "已选择该商品": "Prodotto Già Selezionato",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Nota: Per WeChat Pay, richiedere trasferimenti in-app al portafoglio",
  "微信提现方式": "Metodo di Prelievo WeChat",
  "微信提现到零钱": "Prelievo su Portafoglio WeChat",
  "商家转账到零钱": "Trasferimento Commerciante al Portafoglio",
  "注：根据实际产品开通情况选择": "Seleziona in base alla situazione di attivazione effettiva del prodotto",
  "最低提现额度": "Limite Minimo di Prelievo",
  "佣金结算时间": "Tempo di Liquidazione delle Commissioni",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Nota: Le commissioni di consegna si liquidano nel saldo del corriere n ore dopo il completamento dell'ordine; Imposta a 0 per una liquidazione immediata",
  "请至少选择一种提现方式": "Assicurati di selezionare almeno un metodo di prelievo",
  "佣金结算": "Liquidazione delle Commissioni",
  "是否结算佣金": "Le Commissioni sono in Liquidazione?",
  "已结算": "Liquidato",
  "未结算": "Non Liquidato",
  "送达状态": "Stato di Consegna",
  "查看详情": "Visualizza Dettagli",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Questa operazione utilizzerà il pagamento aziendale WeChat per trasferire sul saldo. Confermi il pagamento?",
  "身份证号": "Numero di Identità",
  "待交押金": "Deposito in Sospeso",
  "审核方式": "Metodo di Revisione",
  "查看": "Visualizza",
  "配送员审核": "Revisione Corriere",
  "添加外卖商品": "Aggiungi Prodotti da Asporto",
  "序号": "Numero",
  "活动折扣": "Sconto Attività",
  "活动库存": "Scorta dell'Attività",
  "添加店内商品": "Aggiungi Prodotti in Negozio",
  "优惠券列表": "Elenco Coupon",
  "发送优惠券": "Invia Coupon",
  "发送对象": "Destinatario",
  "全站会员": "Membri dell'Intero Sito",
  "指定会员": "Membro Designato",
  "选择会员等级": "Seleziona Livello Membro",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Il destinatario ha raggiunto il limite di ricezione del coupon specificato e non ne riceverà più",
  "发送成功": "Inviato con Successo",
  "优惠券ID": "ID Coupon",
  "优惠券名称": "Nome Coupon",
  "优惠券类型": "Tipo di Coupon",
  "最低消费金额": "Importo Minimo di Spesa",
  "优惠方式": "Metodo di Sconto",
  "立减": "Decremento Diretto",
  "打": "Sconto",
  "领取": "Ricevi",
  "天内有效": "Valido per giorni",
  "发放总数量": "Quantità Totale di Distribuzione",
  "不限制": "Non Limitato",
  "已领取数量": "Quantità Ricevuta",
  "修改优惠券": "Modifica Coupon",
  "请输入优惠券名称": "Si prega di Inserire il Nome del Coupon",
  "例如：满100减10": "Ad esempio: Spendi 100 e Ottieni 10 di Sconto",
  "优惠券颜色": "Colore del Coupon",
  "蓝色": "Blu",
  "红色": "Rosso",
  "紫色": "Viola",
  "黄色": "Giallo",
  "满减券": "Coupon di Sconto",
  "折扣券": "Coupon con Sconto",
  "减免金额": "Importo della Riduzione",
  "请输入减免金额": "Inserisci l'Importo della Riduzione",
  "折扣率": "Tasso di Sconto",
  "请输入折扣率": "Si prega di Inserire il Tasso di Sconto",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Il tasso di sconto va da 0 a 10. Per esempio, 9,5 rappresenta uno sconto del 5%, e 0 nessuno sconto",
  "请输入最低消费金额": "Per favore Inserisci l'Importo Minimo di Spesa",
  "后生效": "Effettivo Dopo",
  "请输入发放总数量": "Per favore Inserisci la Quantità Totale di Distribuzione",
  "限制领取的优惠券数量，-1为不限制": "Limita la Quantità Massima di Coupon Ricevuti, -1 per Nessuna Limitazione",
  "是否显示在领券中心": "è Visualizzato nel Centro Coupon?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Il prompto del popup mostrato solo quando il nuovo utente entra per la prima volta nel mini-programma, viene visualizzato una sola volta",
  "引导收藏": "Guida alla Raccolta",
  "编辑类型": "Tipo di Modifica",
  "生日设置": "Impostazioni Compleanno",
  "手机短信": "SMS",
  "分销商用户": "Utente Distributore",
  "分销订单": "Ordini di Distribuzione",
  "分销海报": "Poster di Distribuzione",
  "推荐人": "Referente",
  "下级用户": "Utenti Subordinati",
  "一级": "Livello Uno",
  "二级": "Livello Due",
  "三级": "Livello Tre",
  "成为时间": "Tempo di Diventare",
  "下级": "Subordinato",
  "加入时间": "Tempo di Inserimento",
  "分销商条件": "Condizioni di Distributore",
  "佣金设置": "Impostazioni delle Commissioni",
  "自定义文字": "Testo Personalizzato",
  "申请协议": "Accordo di Domanda",
  "页面背景图": "Immagine di Sfondo della Pagina",
  "分销中心页面": "Pagina Centro Distribuzione",
  "页面标题": "Titolo della Pagina",
  "分销中心": "Centro Distribuzione",
  "非分销商提示": "Promemoria per Non Distributori",
  "您还不是分销商，请先提交申请": "Non sei ancora un distributore, per favore invia prima la domanda",
  "申请成为分销商": "Richiedi di Diventare Distributore",
  "立即加入": "Unisciti Subito",
  "可提现": "Disponibile per Prelievo",
  "待提现佣金": "Commissioni in Attesa di Prelievo",
  "待提现": "In Attesa di Prelievo",
  "已提现金额": "Importo Già Prelievo",
  "去提现": "Esegui Prelievo",
  "申请成为分销商页面": "Pagina di Richiesta di Diventa Distributore",
  "请填写申请信息": "Si prega di Compilare le Informazioni di Domanda",
  "分销商申请协议": "Accordo di Domanda del Distributore",
  "申请成为经销商": "Richiesta di Diventare Rivenditore",
  "审核中提示信息": "Notifica di Revisione in Corso",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "La tua domanda è stata ricevuta ed è in corso la verifica delle informazioni. Attendere pazientemente",
  "去商城逛逛": "Vai a Fare Shopping nel Centro Commerciale",
  "分销订单页面": "Pagina degli Ordini di Distribuzione",
  "我的团队页面": "Pagina del Mio Team",
  "我的团队": "Il Mio Team",
  "团队总人数": "Totale dei Membri del Team",
  "一级团队": "Team Primario",
  "二级团队": "Team Secondario",
  "三级团队": "Team Tersiario",
  "提现明细页面": "Pagina dei Dettagli del Prelievo",
  "审核中": "In Revisione",
  "申请提现页面": "Pagina Domanda Prelievo",
  "申请提现": "Invia Richiesta di Prelievo",
  "请输入要提取的金额": "Si prega di Inserire l'Importo da Prelievare",
  "最低提现佣金": "Commissione Minima per Prelievo",
  "提交申请": "Invia Domanda",
  "佣金结算天数": "Giorni di Liquidazione delle Commissioni",
  "成为分销商条件": "Requisiti per Diventare Distributore",
  "购买指定商品成为分销商": "Diventare distributore acquistando prodotti specifici",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Diventare automaticamente un distributore dopo l'acquisto di prodotti designati, senza necessità di revisione del backend",
  "选择商品": "Seleziona Prodotti",
  "成为下线条件": "Criteri per Diventare Subordinato",
  "首次点击分享链接": "Primo clic sul link condiviso",
  "一级佣金比例": "Tasso di Commissione Primaria",
  "佣金比例范围 0% - 100%": "Intervallo di Tasso di Commissione 0% - 100%",
  "二级佣金比例": "Tasso di Commissione Secondaria",
  "三级佣金比例": "Tasso di Commissione Tersiaria",
  "是否开启分销功能": "Abilitare la Funzione di Distribuzione",
  "分销层级": "Livelli di Distribuzione",
  "一级分销": "Distribuzione Primaria",
  "二级分销": "Distribuzione Secondaria",
  "三级分销": "Distribuzione Tersiaria",
  "分销商内购": "Acquisto Autonomo del Distributore",
  "如开启，分销商自己购买商品，获得一级佣金": "Se abilitato, i distributori ricevono la commissione primaria per gli acquisti effettuati da loro stessi",
  "分销中心首页": "Homepage del Centro di Distribuzione",
  "尺寸：宽750像素 高度227像素": "Dimensioni: Larghezza 750 pixel, Altezza 227 pixel",
  "申请成为分销商页": "Pagina di Richiesta per Diventare Distributore",
  "申请提现页": "Pagina di Richiesta di Prelievo",
  "分销海报设置": "Impostazioni del Poster di Distribuzione",
  "海报背景图": "Immagine di Sfondo del Poster",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimensioni: Larghezza 750 pixel, Altezza maggiore o uguale a 1200 pixel",
  "头像宽度": "Larghezza dell'Avatar",
  "头像样式": "Stile dell'Avatar",
  "正方形": "Quadrato",
  "圆形": "Circolare",
  "昵称字体大小": "Dimensione del Carattere del Nickname",
  "昵称字体颜色": "Colore del Carattere del Nickname",
  "小程序码宽度": "Larghezza del Codice del Mini Programma",
  "小程序码样式": "Stile del Codice del Mini Programma",
  "分销商": "Distributore",
  "一级分销商": "Distributore Primario",
  "分销佣金": "Commissione del Distributore",
  "二级分销商": "Distributore Secondario",
  "三级分销商": "Distributore Tersiario",
  "分销商审核": "Revisione del Distributore",
  "积分明细": "Dettagli dei Punti",
  "变动数量": "Quantità di Variazione",
  "积分名称": "Nome dei Punti",
  "例": "Esempio",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Dopo la modifica del nome dei punti, il nome personalizzato sarà visualizzato su tutte le pagine nell'area dell'acquirente",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Le aziende utilizzano nomi personalizzati dei punti per la promozione del marchio. Ad esempio, JD chiama i punti 'JD Beans' e Taobao li chiama 'Monete del Tesoro'",
  "积分说明": "Spiegazione dei Punti",
  "积分赠送": "Assegnazione dei Punti",
  "是否开启购物送积分": "Abilitare l'Assegnazione dei Punti per gli Acquisti",
  "积分赠送规则": "Regole di Assegnazione dei Punti",
  "如开启则订单完成后赠送用户积分": "Se abilitato, i punti vengono assegnati agli utenti al completamento dell'ordine",
  "订单确认收货已完成": "Conferma dell'Ordine e Ricezione Completata",
  "已完成订单超出后台设置的申请售后期限": "Gli ordini completati superano il periodo di reso impostato nel backend",
  "积分赠送比例": "Tasso di Assegnazione dei Punti",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Inserisci un rapporto tra 0 e 100; le spese di spedizione non sono incluse nella concessione dei punti",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Importo del pagamento dell'ordine (100,00€) * Rapporto di Assegnazione dei Punti (100%) = Punti effettivamente assegnati (100 punti)",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Statistiche di Vendita",
  "会员统计": "Statistiche dei Membri",
  "订单概况": "Panoramica degli Ordini",
  "商品概况": "Panoramica dei Prodotti",
  "今日": "Oggi",
  "累积会员数": "Membri Totali",
  "新增会员数": "Nuovi Membri",
  "成交会员数": "Membri in Transazione",
  "排行榜": "Classifica",
  "用户消费榜": "Classifica di Spesa degli Utenti",
  "积分排行榜": "Classifica dei Punti",
  "邀请人排行榜": "Classifica degli Invitatori",
  "成交会员占比": "Rapporto dei Membri in Transazione",
  "今天": "Oggi",
  "最近7天": "Ultimi 7 Giorni",
  "最近30天": "Ultimi 30 Giorni",
  "最近90天": "Ultimi 90 Giorni",
  "最近180天": "Ultimi 180 Giorni",
  "最近1年": "Ultimo Anno",
  "最近2年": "Ultimi 2 Anni",
  "所有占比": "Rapporto Complessivo",
  "成交会员": "Membri in Transazione",
  "未成交会员": "Membri non in Transazione",
  "新增会员": "Nuovi Membri",
  "最近一周": "Ultima Settimana",
  "最近一个月": "Ultimo Mese",
  "最近三个月": "Ultimi tre mesi",
  "选择店铺": "Seleziona Negozio",
  "查询日期": "Data di Query",
  "近七天": "Ultimi sette giorni",
  "近十五天": "Ultimi quindici giorni",
  "自定义时间": "Tempo Personalizzato",
  "日期": "Data",
  "有效订单数": "Numero di Ordini Validi",
  "选择时间": "Seleziona Tempo",
  "交易统计": "Statistiche delle Transazioni",
  "订单数": "Numero di Ordini",
  "客单价": "Valore Medio dell'Ordine",
  "付款订单": "Ordini Pagati",
  "付款人数": "Numero di Clienti Paganti",
  "商品统计": "Statistiche dei Prodotti",
  "在售商品": "Prodotti Disponibili",
  "件": "Articolo",
  "已付款商品": "Prodotti Pagati",
  "销量TOP10": "Top 10 delle Vendite",
  "浏览TOP10": "Top 10 delle Visualizzazioni",
  "浏览": "Visualizza",
  "排行类型": "Tipo di Classifica",
  "商品总数": "Numero Totale dei Prodotti",
  "已上架商品": "Prodotti in Vendita",
  "已下架商品": "Prodotti Fuori Catalogo",
  "商品导出": "Esportazione dei Prodotti",
  "商品总销量": "Totale Vendite dei Prodotti",
  "商品总销售额": "Ammontare Vendite Totali dei Prodotti",
  "资产总览": "Panoramica degli Asset",
  "财务对账": "Riconciliazione Finanziaria",
  "交易记录": "Registro delle Transazioni",
  "店铺结算": "Regolamento del Negozio",
  "待结算金额": "Ammontare in Attesa di Regolamento",
  "已结算金额": "Importo Regolato",
  "交易概况": "Panoramica delle Transazioni",
  "外卖统计": "Statistiche del Takeout",
  "店内统计": "Statistiche In-Store",
  "订单类型": "Tipo di Ordine",
  "应收金额": "Ammontare Dovuto",
  "实付金额": "Ammontare Pagato",
  "账户概况": "Panoramica dell'Account",
  "订单编号": "Numero dell'Ordine",
  "支付状态": "Stato del Pagamento",
  "付款方式": "Metodo di Pagamento",
  "订单费用": "Costo dell'Ordine",
  "优惠": "Sconto",
  "商户实际收入": "Rendimento Effettivo del Commerciante",
  "商品ID": "ID Prodotto",
  "小计": "Subtotale",
  "请输入提现金额": "Inserisci l'importo da Prelevare",
  "请输入打款方式": "Inserisci il Metodo di Pagamento",
  "支付宝真实姓名": "Nome Reale Alipay",
  "请输入支付宝真实姓名": "Inserisci il Nome Reale di Alipay",
  "开户行名称": "Nome della Banca",
  "银行开户名": "Nome del Conto Bancario",
  "真实姓名": "Nome Reale",
  "应付金额": "Importo Dovuto",
  "实付总额": "Importo Totale Pagato",
  "商户": "Commerciante",
  "结算金额": "Importo del Regolamento",
  "店铺结算金额": "Importo del Regolamento del Negozio",
  "操作提示": "Suggerimenti Operativi",
  "订单结算金额 = 店铺结算总金额(含运费)": "Importo di Regolamento dell'Ordine = Importo Totale del Regolamento del Negozio (comprensivo della Spedizione)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Entrate del Negozio = Importo Totale del Regolamento del Negozio - Importo dei Rimborsi del Negozio",
  "订单日期": "Data dell'Ordine",
  "订单结算金额": "Importo di Regolamento dell'Ordine",
  "配送费金额": "Importo della Tassa di Consegna",
  "商品编码": "Codice Prodotto",
  "可用余额": "Saldo Disponibile",
  "提现概况": "Panoramica dei Prelievi",
  "搜索": "Cerca",
  "支出": "Spesa",
  "金额": "Importo",
  "收支类型": "Tipo di Entrate e Spese",
  "确认要退吗?": "Confermare il Reso?",
  "申请成功": "Richiesta Accettata",
  "门店总金额": "Ammontare Totale del Negozio",
  "累计收入": "Entrate Accumulate",
  "访客数": "Numero di Visitatori",
  "访问量": "Volume di Visite",
  "店铺收藏数": "Numero di Preferiti del Negozio",
  "商品收藏数": "Numero di Preferiti dei Prodotti",
  "访问数": "Numero di Visite",
  "收藏数": "Numero di Preferiti",
  "数": "Numero",
  "待支付": "Pagamento in Attesa",
  "实际到账": "Importo Effettivamente Ricevuto",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "物流公司": "Azienda Logistica",
  "chatgpt设置": "Impostazioni ChatGPT",
  "消息设置": "Impostazioni dei Messaggi",
  "短信设置": "Impostazioni SMS",
  "上传设置": "Impostazioni di Upload",
  "清理缓存": "Pulizia della Cache",
  "网址后缀英文名称": "Nome in Inglese per il Suffisso del Sito Web",
  "英文名称": "Nome in Inglese",
  "默认头像": "Avatar Predefinito",
  "英文名称必须只包含数字和英文字母": "Il Nome in Inglese deve contenere solo numeri e lettere",
  "恭喜你，商城设置成功": "Congratulazioni, le Impostazioni del Negozio sono state applicate con successo",
  "表单数据不符合规则": "I dati del modulo non sono conformi alle regole",
  "剩余额度": "Limite Residuo",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Quando il saldo è insufficiente, funzionalità come Servizio Clienti Intelligente, Creazione Magica AI e Traduzione Multilingue saranno disabilitate",
  "使用明细": "Dettagli dell'Uso",
  "消费": "Spesa",
  "额度": "Quota",
  "数据缓存": "Cache dei Dati",
  "恭喜你，清理成功": "Congratulazioni, il processo di pulizia è riuscito",
  "管理员列表": "Lista degli Amministratori",
  "角色管理": "Gestione dei Ruoli",
  "登录日志": "Log di Accesso",
  "操作日志": "Log delle Operazioni",
  "添加管理员": "Aggiungi Amministratore",
  "管理员ID": "ID Amministratore",
  "用户名": "Nome Utente",
  "所属角色": "Ruolo Assegnato",
  "超级管理员": "Super Amministratore",
  "所属门店": "Negozio di Affiliazione",
  "门店状态": "Stato del Negozio",
  "已删除": "Eliminato",
  "未删除": "Non Eliminato",
  "账号状态": "Stato dell'Account",
  "恭喜你，该管理员删除成功": "Congratulazioni, l'amministratore è stato eliminato con successo",
  "请输入用户名": "Inserisci il nome utente",
  "修改管理员": "Modifica Amministratore",
  "添加角色": "Aggiungi Ruolo",
  "角色ID": "ID Ruolo",
  "角色名称": "Nome del Ruolo",
  "恭喜你，该角色删除成功": "Congratulazioni, il ruolo è stato eliminato con successo",
  "编辑角色": "Modifica Ruolo",
  "请输入角色名称": "Inserisci il nome del ruolo",
  "权限列表": "Elenco delle Autorizzazioni",
  "请输入用户名和真实姓名": "Inserisci il nome utente e il nome reale",
  "登录状态": "Stato di Accesso",
  "全部标记为已读": "Segna Tutto come Letto",
  "公告详情": "Dettagli dell'Annuncio",
  "全部标记为已读消息吗?": "Segnare tutti i messaggi come letti?",
  "操作成功!": "Operazione riuscita!",
  "已取消操作": "Operazione annullata",
  "订单流程设置": "Impostazioni del Processo di Ordinazione",
  "已支付订单": "Ordini Pagati",
  "分钟后自动核销": "si convalida automaticamente dopo minuti",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Se non convalidato nel periodo, il sistema convalida automaticamente, impostare su 0 per non convalidare automaticamente",
  "积分商城订单流程设置": "Impostazioni del Processo di Ordine del Centro Punti",
  "已发货订单": "Ordini Spediti",
  "天后自动核销": "convalida automaticamente dopo giorni",
  "不包括桌台订单": "esclusi gli ordini al tavolo",
  "恭喜你，交易设置成功": "Congratulazioni, le impostazioni della transazione sono state applicate con successo",
  "当前版本": "Versione Attuale",
  "试用版": "Versione di Prova",
  "专业版": "Edizione Professionale",
  "高级版": "Edizione Avanzata",
  "至尊版": "Edizione Suprema",
  "到期日期": "Data di Scadenza",
  "永不过期": "Mai in Scadenza",
  "欢迎您": "Benvenuto",
  "修改密码": "Modifica Password",
  "此操作将退出登录, 是否继续?": "Questa operazione ti disconnetterà, desideri continuare?",
  "原始密码": "Password Originale",
  "新密码": "Nuova Password",
  "确认新密码": "Conferma Nuova Password",
  "系统公告": "Annuncio di Sistema",
  "请至少选择一件产品商品！": "Seleziona almeno un prodotto!",
  "超链接设置": "Impostazioni dell'Iperlink",
  "图像预览": "Anteprima Immagine",
  "页面": "Pagina",
  "当前链接": "Collegamento Attuale",
  "暂无": "Nessuno",
  "页面路径": "Percorso della Pagina",
  "注意一": "Nota Uno",
  "注意二": "Nota Due",
  "注意三": "Nota Tre",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Per lo stesso mini-programma collegato ad altri mini-programmi, è consentito un massimo di 10 collegamenti; superare questo limite li renderà inefficaci",
  "不能填写自身小程序appid": "Non puoi inserire l'appid del mini-programma corrente",
  "小程序链接留空默认跳到小程序首页": "Lasciare il campo di collegamento al mini-programma vuoto lo indirizzerà automaticamente alla homepage del mini-programma",
  "分类": "Categoria",
  "选择": "Seleziona",
  "签到": "Registrati",
  "积分商城": "Centro Punti",
  "秒杀": "Vendita Lampo",
  "拼团": "Acquisto di Gruppo",
  "砍价": "Strappare uno Sconto",
  "领券中心": "Centro Coupon",
  "生日有礼": "Regalo di Compleanno",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "La pagina web collegata deve supportare SSL e iniziare con https://, altrimenti non sarà possibile il reindirizzamento",
  "链接的域名必须是备案域名，否则无法跳转": "Il nome di dominio collegato deve essere un dominio registrato, altrimenti non sarà possibile il reindirizzamento",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Il tuo dominio del sito web deve essere aggiunto al dominio aziendale della piattaforma pubblica del mini-programma di WeChat, puoi fornire ulteriori dettagli?",
  "选择文章列表": "Seleziona Elenco degli Articoli",
  "文章标题": "Titolo dell'Articolo",
  "选择规格": "Seleziona Specifiche",
  "产品/规格": "Prodotto/Specifiche",
  "已选": "Selezionati",
  "查看物流": "Visualizza la Logistica",
  "请输入收货人": "Inserisci il destinatario",
  "请输入收获电话": "Inserisci il telefono del destinatario",
  "省": "Provincia",
  "市": "Città",
  "区": "Distretto",
  "现金收款": "Pagamento in Contanti",
  "余额收款": "Pagamento con Saldo",
  "其他方式": "Altri Metodi",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Inserisci l'ID membro per cercare il membro, quindi fai clic su conferma quando hai finito",
  "请输入会员ID": "Inserisci l'ID membro",
  "会员昵称": "Soprannome del Membro",
  "余额总计": "Saldo Totale",
  "登录会员仅作为积分累计，无法享受其他优惠": "I membri registrati possono solo accumulare punti e non beneficiare di altri sconti",
  "取消收款": "Annullare Pagamento",
  "收款": "Ricevere Pagamento",
  "请输入会员手机号": "Inserisci il numero di telefono del membro",
  "该用户不存在": "Questo utente non esiste",
  "注册": "Registrati",
  "平台名称": "Nome della Piattaforma",
  "请输入平台名称": "Inserisci il nome della piattaforma",
  "所在地区": "Posizione",
  "请选择所在地区": "Seleziona la posizione",
  "平台账户名": "Nome dell'Account della Piattaforma",
  "请输入平台账户名": "Inserisci il nome dell'account della piattaforma",
  "平台账户密码": "Password dell'Account della Piattaforma",
  "是否连锁": "è un franchising?",
  "请输入您的地址": "Inserisci il tuo indirizzo",
  "请输入您的联系电话": "Inserisci il tuo numero di telefono di contatto",
  "请输入您的联系邮箱": "Inserisci la tua email di contatto",
  "联系邮箱": "Email di Contatto",
  "不能全是空格": "Non può essere vuoto",
  "不能包含空格": "Non può contenere spazi",
  "长度不能小于6位": "La lunghezza non può essere inferiore a 6 caratteri",
  "请填写确认密码": "Inserisci la password di conferma",
  "确认密码不一致": "Le password non corrispondono",
  "联系电话和联系邮箱至少填写一个": "Per favore fornisce almeno un numero di telefono o una email di contatto",
  "注册成功,请前往登录": "Registrazione avvenuta con successo, procedi con l'accesso",
  "清空": "Svuota",
  "确认": "Conferma",
  "限时免费": "Gratuito per un periodo limitato",
  // ==================== Components end     =========

  // ==================== 其它  start    ==============
  '菜品总量': 'Quantità totale dei piatti',
  '菜品排行榜': 'Classifica dei piatti',
  '商家信息': 'Informazioni del commerciante',
  '与店内营业时间相同': 'Uguale agli orari di apertura del negozio',
  '菜品分类': 'Categoria dei piatti',
  '通告': 'Avviso',
  '商家店名': 'Nome del negozio',
  '请输入商家店名': 'Si prega di inserire il nome del negozio',
  '温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱': 'Gentile avviso: Dopo la scelta, si prega di evitare modifiche casuali per evitare disordini nei dati dei piatti del negozio',
  '网址后缀设置': 'Impostazione del suffisso dell\'URL',
  '选填，设置后缀可替换下列网址末尾的数字id，方便记忆': 'Opzionale, impostando il suffisso è possibile sostituire l\'ID numerico alla fine degli URL elencati, facilitandone la memorizzazione',
  '网址设置': 'Configurazione dell\'URL',
  '手机网站二维码': 'QR Code del sito web mobile',
  '按菜品收费': 'Tariffa per piatto',
  '外卖菜品': 'Piatti da asporto',
  '店内菜品': 'Piatti per consumazione in loco',
  '菜品管理': 'Gestione dei piatti',
  '菜品名称': 'Nome del piatto',
  '请输入菜品名称': 'Si prega di inserire il nome del piatto',
  '此菜品正在参加活动，不能修改规格': 'Questo piatto sta partecipando a un\'attività, non è possibile modificare le specifiche',
  '通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。': 'Attraverso la tecnologia dell\'intelligenza artificiale, è possibile compilare automaticamente le informazioni dettagliate del piatto in base al nome, come ingredienti, punti di vendita, gusti, ecc.',
  '请填写菜品详情': 'Si prega di compilare i dettagli del piatto',
  '菜品详情': 'Dettagli del piatto',
  '菜品图片': 'Immagine del piatto',
  '请上传菜品图片': 'Si prega di caricare l\'immagine del piatto',
  'AI未识别到您的菜品图片': 'IA non ha riconosciuto l\'immagine del tuo piatto',
  '本菜品正在参加活动，不能删除规格！': 'Questo piatto sta partecipando a un\'attività, non è possibile eliminare le specifiche',
  '菜品加料': 'Ingredienti aggiuntivi del piatto',
  '菜品状态': 'Stato del piatto',
  '选择菜品状态': 'Seleziona lo stato del piatto',
  '菜品排序': 'Ordinamento dei piatti',
  '请填写菜品名称': 'Si prega di inserire il nome del piatto',
  '你选择菜品分类': 'Hai selezionato una categoria di piatti',
  '菜品卖点': 'Punto vendita del piatto',
  '菜品属性': 'Attributi del piatto',
  '菜品同步': 'Sincronizzazione dei piatti',
  '是否同步菜品至外卖': 'Sincronizzazione dei piatti per l\'asporto',
  '是否同步菜品至店内': 'Sincronizzazione dei piatti per il ristorante',
  '搜索菜品': 'Cerca piatti',
  '菜品原价': 'Prezzo originale del piatto',
  '菜品来源': 'Origine del piatto',
  '菜品列表': 'Elenco dei piatti',
  '菜品销量': 'Vendite del piatto',
  '通告管理': 'Gestione degli avvisi',
  '添加通告': 'Aggiungi un avviso',
  '通告ID': 'ID dell\'avviso',
  '通告标题': 'Titolo dell\'avviso',
  '通告分类': 'Categoria dell\'avviso',
  '通告排序': 'Ordina gli avvisi',
  '通告状态': 'Stato dell\'avviso',
  '通告内容': 'Contenuto dell\'avviso',
  '编辑通告': 'Modifica avviso',
  'AI助理形象选择': 'Selezione dell\'immagine dell\'assistente AI',
  '菜品信息': 'Informazioni del piatto',
  '菜品总价': 'Prezzo totale dei piatti',
  '请按实际店名填写，将显示在商家点餐网站上': 'Si prega di inserire il nome effettivo del negozio, che verrà visualizzato sul sito di ordinazione',
  '首次添加桌位请先添加桌位类型': 'Per aggiungere un tavolo per la prima volta, si prega di aggiungere prima un tipo di tavolo',
  '首次添加桌位请先添加区域': 'Per aggiungere un tavolo per la prima volta, si prega di aggiungere prima un\'area',
  '设置店内区域，如A区、B区、大厅、包厢等': 'Impostare le aree interne, come Area A, Area B, Sala principale, Sale private, ecc.',
  '设置桌位类型，如二人桌、四人桌、大桌、小桌等': 'Impostare i tipi di tavoli, come tavolo per due, tavolo per quattro, tavolo grande, tavolino, ecc.',
  '该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）': 'Questo account è utilizzato per accedere al sito della cassa (è possibile trovare l\'URL della cassa nella pagina di "Impostazioni dell\'URL")',
  '该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）': 'Questo account è utilizzato per accedere al sito della cucina (è possibile trovare l\'URL della cucina nella pagina di "Impostazioni dell\'URL")',
  '如无需设置税率可不填写': 'Se non è necessario impostare l\'aliquota fiscale, è possibile lasciare il campo vuoto',
  '打款信息': 'Informazioni sul pagamento',
  '开户行': 'Nome della banca',
  '菜品分组': 'Gruppo di piatti',
  '自定义名称，仅用于商家自己区分分类，不会展示给顾客': 'Nome personalizzato, utilizzato solo per la distinzione interna del commerciante, non sarà mostrato ai clienti',
  '手机网站编辑': 'Modifica del sito web mobile',
  '恢复初始默认页面': 'Ripristina la pagina predefinita iniziale',
  '通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上': 'Gli avvisi sono notifiche, annunci, presentazioni aziendali, ecc., visualizzati sul sito web mobile; quando sono in modalità "Mostra", l\'avviso verrà visualizzato sul sito web mobile',
  '注：如开启则移动端显示余额提现': 'Nota: Se abilitato, il prelievo del saldo verrà visualizzato sul dispositivo mobile',
  '菜品重量': 'Peso del piatto',
  '请填写菜品重量': 'Si prega di inserire il peso del piatto',
  '菜品设置': 'Impostazioni del piatto',
  '已选择该菜品': 'Hai selezionato questo piatto',
  '添加外卖菜品': 'Aggiungi piatto da asporto',
  '添加店内菜品': 'Aggiungi piatto per consumazione in loco',
  '购买指定菜品成为分销商': 'Acquista determinati piatti per diventare un distributore',
  '购买指定菜品付款后自动成为分销商，无需后台审核': 'Acquistando determinati piatti e pagando diventerai automaticamente un distributore, senza bisogno di approvazione dall\'amministrazione',
  '如开启，分销商自己购买菜品，获得一级佣金': 'Se abilitato, i distributori possono acquistare i piatti e ottenere una commissione di primo livello',
  '订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)”': 'Importo del pagamento dell\'ordine (100.00€) * Percentuale di punti premio (100%) = Punti premio effettivi (100 punti)"',
  '菜品概况': 'Panoramica dei piatti',
  '菜品统计': 'Statistiche dei piatti',
  '在售菜品': 'Piatti in vendita',
  '已付款菜品': 'Piatti già pagati',
  '菜品总数': 'Numero totale dei piatti',
  '已上架菜品': 'Piatti già in vendita',
  '已下架菜品': 'Piatti già rimossi dalla vendita',
  '菜品导出': 'Esporta piatti',
  '菜品总销量': 'Volume totale di vendite dei piatti',
  '菜品总销售额': 'Fatturato totale dei piatti',
  '菜品ID': 'ID del piatto',
  '菜品收藏数': 'Numero di piatti salvati',
  '请至少选择一件产品菜品！': 'Si prega di selezionare almeno un piatto!',
  "区域管理": "Gestione Regionale",
  "点餐管理系统": "Sistema di ordinazione",
  "首页": "Home",
  "余额支付": "Pagamento del saldo",
  "线下支付(现金支付)": "Pagamento offline (Contanti)",
  "线下支付(自有微信支付)": "Pagamento offline (WeChat Pay personale)",
  "线下支付(自有支付宝支付)": "Pagamento offline (Alipay personale)",
  "线下支付(POS刷卡支付)": "Pagamento offline (Pagamento con carta POS)",
  "待配送": "Da consegnare",
  "配送中": "In consegna",
  "待接单": "Da accettare",
  "待取货": "Da ritirare",
  "已配送": "Consegnato",
  "已收货": "Ricevuto",
  "待收货": "Da ricevere",
  "待取消": "Da annullare",
  "会员": "Membro",
  "商家": "Commerciante",
  "供应商": "Fornitore",
  "分销": "Distribuzione",
  "通知": "Notifica",
  "已付款": "Pagato",
  "用户下单": "Ordine effettuato dall'utente",
  "收银台下单": "Ordine effettuato al banco",
  "扫码下单": "Ordine tramite codice a barre",
  "团购下单": "Ordine gruppo",
  "商城订单": "Ordine mall",
  "积分商城订单": "Ordine punti mall",
  "余额充值订单": "Ordine ricarica saldo",
  "购卡订单": "Ordine carta",
  "券包订单": "Ordine pacchetto buoni",
  "配送员押金订单": "Ordine deposito personale consegniere",
  "快递配送": "Consegna espresso",
  "个人中心": "Centro personale",
  "在地图中点击确认位置，坐标自动填入":"Clicca per confermare la posizione sulla mappa, e le coordinate saranno automaticamente riempite.",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算":"Nota: Quando l'ordine viene completato dopo n giorni, la commissione di distribuzione per tale ordine viene liquidata sul saldo del distributore. Se impostato a 0 giorni, la liquidazione avviene al momento del completamento dell'ordine.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Per aggiungere un coupon, per favore vai alla pagina 'Marketing' - 'Strumenti di marketing' - 'Coupon'.",
  // ==================== 其它  end    ================


  ...itLocale
}


export default it



// WEBPACK FOOTER //
// ./src/i18n/langs/it.js